/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * 
 * This file is automatically generated from:
 * - constants/shared_constants.json
 * - constants/voice_metadata.json
 * 
 * To update: Edit the source JSON files and run 'npm run generate'
 * Generated at: 2026-10-14T12:02:59.696Z
 */

// Type definitions (generated from JSON)
export type Language = 'cmn' | 'es' | 'en-us' | 'hi' | 'ar' | 'bn' | 'pt-br' | 'ru' | 'ja' | 'pa' | 'de' | 'id' | 'fr' | 'tr' | 'ko' | 'te' | 'vi' | 'ta' | 'it' | 'ur' | 'es-419' | 'ca' | 'fr-be' | 'fr-ch' | 'ro' | 'an' | 'ht' | 'pap' | 'en-gb' | 'en-029' | 'en-gb-scotland' | 'en-gb-x-gbclan' | 'en-gb-x-gbcwmd' | 'en-gb-x-rp' | 'nl' | 'af' | 'da' | 'is' | 'nb' | 'sv' | 'bg' | 'bs' | 'cs' | 'hr' | 'mk' | 'pl' | 'ru-lv' | 'sk' | 'sl' | 'sr' | 'yue' | 'hak' | 'vi-vn-x-central' | 'vi-vn-x-south' | 'shn' | 'my' | 'ms' | 'as' | 'bpy' | 'gu' | 'kok' | 'mr' | 'ne' | 'or' | 'sd' | 'si' | 'kn' | 'ml' | 'am' | 'mt' | 'az' | 'ba' | 'kk' | 'ky' | 'tt' | 'uz' | 'fa' | 'fa-latn' | 'ku' | 'cy' | 'ga' | 'gd' | 'lt' | 'lv' | 'et' | 'fi' | 'hu' | 'kl' | 'quc' | 'gn' | 'tpw' | 'el' | 'grc' | 'sq' | 'hy' | 'hyw' | 'la' | 'ka' | 'sw' | 'tn' | 'om' | 'mi' | 'nci' | 'lfn' | 'eo' | 'ia' | 'jbo' | 'zh' | 'no' | 'be' | 'co' | 'eu' | 'fy' | 'fur' | 'gl' | 'lb' | 'lmo' | 'ltg' | 'scn' | 'szl' | 'uk' | 'vec' | 'yi' | 'ace' | 'ay' | 'ban' | 'bho' | 'bjn' | 'bug' | 'ceb' | 'dv' | 'ilo' | 'iw' | 'jv' | 'kas' | 'km' | 'lo' | 'mai' | 'min' | 'mn' | 'mni-mtei' | 'pag' | 'ps' | 'qu' | 'sa' | 'su' | 'tg' | 'th' | 'tk' | 'tl' | 'ug' | 'war' | 'bm' | 'ee' | 'ha' | 'ig' | 'kab' | 'kam' | 'knc' | 'kri' | 'lg' | 'ln' | 'luo' | 'mg' | 'nus' | 'ny' | 'rw' | 'sm' | 'sn' | 'so' | 'st' | 'taq' | 'ti' | 'ts' | 'xh' | 'yo' | 'zu' | 'crh' | 'haw';

// Provider types (generated from backend constants)
export type TTSProvider = 'kokoro' | 'edge_tts' | 'google' | 'pyttsx3' | 'f5_tts' | 'chatterbox' | 'minimax' | 'chatterbox_turbo' | 'elevenlabs';
export type STTProvider = 'whisperx' | 'whisper_v3';
export type LLMProvider = 'ollama' | 'openrouter' | 'runpod';
export type VideoResolution = '1920x1080' | '1280x720' | '1080x1920' | '720x1280' | '1080x1080' | '720x720' | '512x512' | '912x512' | '512x912' | '3840x2160';
// Script / config video tone (professional/cinematic/documentary/...): the
// keys of constants/templates/styles.py:STYLE_PRESETS, the list the video
// worker validates `style` against. THREE distinct video-style
// concepts share overlapping string VALUES but MUST keep separate SYMBOLS:
//   - ScriptVideoStyle (this one) — LLM script-generation tone hints.
//   - AIVisualStyle (constants/videoStyles.ts) — AI visual aesthetics
//     (none/ghibli/fantasy/...).
//   - NarrationVideoStyle (services/narrationVideo.ts) — narration-audio→video
//     service styles (professional/cinematic/dramatic/...).
// Same VALUES may overlap (e.g. 'cinematic'); never collapse the SYMBOLS.
export type ScriptVideoStyle = 'professional' | 'inspirational' | 'documentary' | 'tech' | 'educational' | 'cinematic' | 'minimalist' | 'kids' | 'news' | 'artistic' | 'dynamic' | 'dramatic' | 'promotional' | 'energetic';

// Interface types
export interface VoiceOption {
  id: string;
  name: string;
  gender: 'male' | 'female' | 'neutral';
  language: Language;
  provider: TTSProvider;
  grade?: string;
  emoticon?: string;
}

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
  /** Tooltip / hint shown when this option is disabled — e.g. why a TTS provider is offline. */
  disabled_reason?: string;
  free?: boolean;
  local_only?: boolean;
  is_cloud?: boolean;
  id?: string;
  name?: string;
  description?: string;
}

export interface DurationOption {
  value: number;
  label: string;
  seconds: number;
  disabled?: boolean;
  premium?: boolean;
}

export interface ResolutionOption {
  value: string;
  label: string;
  width?: number;
  height?: number;
  aspectRatio?: string;
  aspect_ratio?: string;
  orientation?: string;
  short_label?: string;
  free?: boolean;
  premium?: boolean;
}

export interface LanguageOption {
  value: string;
  label: string;
  flag?: string;
  english_label?: string;
  region?: string;
  is_top_20?: boolean;
}

export interface StyleOption {
  value: string;
  label: string;
  description?: string;
  short_label?: string;
}

// ============================================
// SHARED CONSTANTS FROM shared_constants.json
// ============================================

export const DEFAULT_VALUES = {
  tts_provider: "kokoro",
  llm_provider: "openrouter",
  llm_model_openrouter: "google/gemini-2.5-flash-lite",
  llm_model_ollama: "gemma3:12b",
  llm_model_seo: "google/gemini-2.5-flash",
  language: "en-us",
  resolution: "1920x1080",
  style: "educational",
  duration_minutes: 0.25,
  adjust_timing_to_narration: true,
  subtitle_mode: "soft",
  // Aliases for backward compatibility
  TTS_PROVIDER: "kokoro",
  LLM_PROVIDER: "openrouter",
  LLM_MODEL: "google/gemini-2.5-flash-lite",
  LLM_MODEL_OLLAMA: "gemma3:12b",
  LANGUAGE: "en-us",
  RESOLUTION: "1920x1080",
  STYLE: "educational",
  DURATION_MINUTES: 0.25,
  ADJUST_TIMING_TO_NARRATION: true
} as const;

export const TTS_PROVIDERS: SelectOption[] = [
  {
    "disabled": false,
    "label": "Kokoro (High Quality Neural)",
    "value": "kokoro"
  },
  {
    "disabled": false,
    "label": "Edge TTS (Microsoft Neural, 100+ Languages)",
    "value": "edge_tts"
  },
  {
    "disabled": false,
    "label": "Google TTS (Medium Quality)",
    "value": "google"
  },
  {
    "disabled": false,
    "label": "PyTTSx3 (Offline, 107 Languages)",
    "value": "pyttsx3"
  },
  {
    "disabled": false,
    "label": "F5-TTS (Voice Cloning, MIT)",
    "value": "f5_tts"
  },
  {
    "disabled": false,
    "label": "Chatterbox (Emotions, 23 Languages)",
    "value": "chatterbox"
  },
  {
    "disabled": false,
    "label": "MiniMax Speech 02 HD (Cloud)",
    "value": "minimax"
  },
  {
    "disabled": false,
    "label": "Chatterbox Turbo (Cloud)",
    "value": "chatterbox_turbo"
  },
  {
    "disabled": false,
    "label": "Elevenlabs",
    "value": "elevenlabs"
  }
];

export const STT_PROVIDERS: SelectOption[] = [
  {
    "disabled": false,
    "is_cloud": false,
    "label": "WhisperX (Local)",
    "value": "whisperx"
  },
  {
    "disabled": false,
    "is_cloud": true,
    "label": "Whisper V3 Large (Cloud)",
    "value": "whisper_v3"
  }
];

export const LLM_PROVIDERS: SelectOption[] = [
  {
    "description": "Requires local Ollama installation",
    "disabled": false,
    "label": "Ollama (Local only)",
    "local_only": true,
    "value": "ollama"
  },
  {
    "disabled": false,
    "label": "OpenRouter (Recommended)",
    "value": "openrouter"
  },
  {
    "description": "RunPod Public Endpoints (Cloud)",
    "disabled": false,
    "is_cloud": true,
    "label": "RunPod (Cloud)",
    "value": "runpod"
  }
];

export const LLM_MODELS: Record<string, SelectOption[]> = {
  "ollama": [
    {
      "disabled": false,
      "id": "gemma3:27b",
      "label": "Gemma 3 27B",
      "name": "Gemma 3 27B",
      "value": "gemma3:27b"
    },
    {
      "disabled": false,
      "id": "gemma3:12b",
      "label": "Gemma 3 12B (Default)",
      "name": "Gemma 3 12B (Default)",
      "value": "gemma3:12b"
    },
    {
      "disabled": false,
      "id": "gemma3:4b",
      "label": "Gemma 3 4B",
      "name": "Gemma 3 4B",
      "value": "gemma3:4b"
    },
    {
      "disabled": false,
      "id": "gemma3:1b",
      "label": "Gemma 3 1B",
      "name": "Gemma 3 1B",
      "value": "gemma3:1b"
    },
    {
      "disabled": false,
      "id": "gemma2:9b",
      "label": "Gemma 2 9B",
      "name": "Gemma 2 9B",
      "value": "gemma2:9b"
    },
    {
      "disabled": false,
      "id": "gemma2:2b",
      "label": "Gemma 2 2B",
      "name": "Gemma 2 2B",
      "value": "gemma2:2b"
    },
    {
      "disabled": false,
      "id": "gemma:2b",
      "label": "Gemma 2B",
      "name": "Gemma 2B",
      "value": "gemma:2b"
    },
    {
      "disabled": false,
      "id": "gemma:7b",
      "label": "Gemma 7B",
      "name": "Gemma 7B",
      "value": "gemma:7b"
    },
    {
      "disabled": false,
      "id": "qwen3:32b",
      "label": "Qwen3 32B",
      "name": "Qwen3 32B",
      "value": "qwen3:32b"
    },
    {
      "disabled": false,
      "id": "qwen3:14b",
      "label": "Qwen3 14B",
      "name": "Qwen3 14B",
      "value": "qwen3:14b"
    },
    {
      "disabled": false,
      "id": "qwen3:8b",
      "label": "Qwen3 8B",
      "name": "Qwen3 8B",
      "value": "qwen3:8b"
    },
    {
      "disabled": false,
      "id": "qwen2.5:32b",
      "label": "Qwen2.5 32B",
      "name": "Qwen2.5 32B",
      "value": "qwen2.5:32b"
    },
    {
      "disabled": false,
      "id": "qwen2.5:14b",
      "label": "Qwen2.5 14B",
      "name": "Qwen2.5 14B",
      "value": "qwen2.5:14b"
    },
    {
      "disabled": false,
      "id": "qwen2.5:7b",
      "label": "Qwen2.5 7B",
      "name": "Qwen2.5 7B",
      "value": "qwen2.5:7b"
    },
    {
      "disabled": false,
      "id": "qwen2.5:3b",
      "label": "Qwen2.5 3B",
      "name": "Qwen2.5 3B",
      "value": "qwen2.5:3b"
    },
    {
      "disabled": false,
      "id": "qwen2.5-coder:14b",
      "label": "Qwen2.5 Coder 14B",
      "name": "Qwen2.5 Coder 14B",
      "value": "qwen2.5-coder:14b"
    },
    {
      "disabled": false,
      "id": "qwen2.5-coder:7b",
      "label": "Qwen2.5 Coder 7B",
      "name": "Qwen2.5 Coder 7B",
      "value": "qwen2.5-coder:7b"
    },
    {
      "disabled": false,
      "id": "deepseek-r1:32b",
      "label": "DeepSeek-R1 32B",
      "name": "DeepSeek-R1 32B",
      "value": "deepseek-r1:32b"
    },
    {
      "disabled": false,
      "id": "deepseek-r1:14b",
      "label": "DeepSeek-R1 14B",
      "name": "DeepSeek-R1 14B",
      "value": "deepseek-r1:14b"
    },
    {
      "disabled": false,
      "id": "deepseek-r1:8b",
      "label": "DeepSeek-R1 8B",
      "name": "DeepSeek-R1 8B",
      "value": "deepseek-r1:8b"
    },
    {
      "disabled": false,
      "id": "deepseek-r1:7b",
      "label": "DeepSeek-R1 7B",
      "name": "DeepSeek-R1 7B",
      "value": "deepseek-r1:7b"
    },
    {
      "disabled": false,
      "id": "llama3.3:70b",
      "label": "Llama 3.3 70B",
      "name": "Llama 3.3 70B",
      "value": "llama3.3:70b"
    },
    {
      "disabled": false,
      "id": "llama3.2:3b",
      "label": "Llama 3.2 3B",
      "name": "Llama 3.2 3B",
      "value": "llama3.2:3b"
    },
    {
      "disabled": false,
      "id": "llama3.2:1b",
      "label": "Llama 3.2 1B",
      "name": "Llama 3.2 1B",
      "value": "llama3.2:1b"
    },
    {
      "disabled": false,
      "id": "llama3.1:8b",
      "label": "Llama 3.1 8B",
      "name": "Llama 3.1 8B",
      "value": "llama3.1:8b"
    },
    {
      "disabled": false,
      "id": "llama3:8b",
      "label": "Llama 3 8B",
      "name": "Llama 3 8B",
      "value": "llama3:8b"
    },
    {
      "disabled": false,
      "id": "mistral-small:24b",
      "label": "Mistral Small 24B",
      "name": "Mistral Small 24B",
      "value": "mistral-small:24b"
    },
    {
      "disabled": false,
      "id": "mistral-nemo:12b",
      "label": "Mistral Nemo 12B",
      "name": "Mistral Nemo 12B",
      "value": "mistral-nemo:12b"
    },
    {
      "disabled": false,
      "id": "mistral:7b",
      "label": "Mistral 7B",
      "name": "Mistral 7B",
      "value": "mistral:7b"
    },
    {
      "disabled": false,
      "id": "mixtral:8x7b",
      "label": "Mixtral 8x7B",
      "name": "Mixtral 8x7B",
      "value": "mixtral:8x7b"
    },
    {
      "disabled": false,
      "id": "phi4:14b",
      "label": "Phi-4 14B",
      "name": "Phi-4 14B",
      "value": "phi4:14b"
    },
    {
      "disabled": false,
      "id": "phi:2.7b",
      "label": "Phi 2.7B",
      "name": "Phi 2.7B",
      "value": "phi:2.7b"
    },
    {
      "disabled": false,
      "id": "llama2:7b",
      "label": "Llama 2 7B",
      "name": "Llama 2 7B",
      "value": "llama2:7b"
    },
    {
      "disabled": false,
      "id": "llama2:13b",
      "label": "Llama 2 13B",
      "name": "Llama 2 13B",
      "value": "llama2:13b"
    },
    {
      "disabled": false,
      "id": "llama2:70b",
      "label": "Llama 2 70B",
      "name": "Llama 2 70B",
      "value": "llama2:70b"
    },
    {
      "disabled": false,
      "id": "neural-chat:7b",
      "label": "Neural Chat 7B",
      "name": "Neural Chat 7B",
      "value": "neural-chat:7b"
    },
    {
      "disabled": false,
      "id": "starling-lm:7b",
      "label": "Starling LM 7B",
      "name": "Starling LM 7B",
      "value": "starling-lm:7b"
    },
    {
      "disabled": false,
      "id": "codellama:7b",
      "label": "CodeLlama 7B",
      "name": "CodeLlama 7B",
      "value": "codellama:7b"
    },
    {
      "disabled": false,
      "id": "codellama:13b",
      "label": "CodeLlama 13B",
      "name": "CodeLlama 13B",
      "value": "codellama:13b"
    },
    {
      "disabled": false,
      "id": "codellama:34b",
      "label": "CodeLlama 34B",
      "name": "CodeLlama 34B",
      "value": "codellama:34b"
    }
  ],
  "openrouter": [
    {
      "disabled": false,
      "id": "apodex/apodex-1.1-mini:free",
      "label": "Apodex 1.1 Mini",
      "name": "Apodex 1.1 Mini",
      "value": "apodex/apodex-1.1-mini:free"
    },
    {
      "disabled": false,
      "id": "liquid/lfm-2.5-2.6b:free",
      "label": "Lfm 2.5 2.6B",
      "name": "Lfm 2.5 2.6B",
      "value": "liquid/lfm-2.5-2.6b:free"
    },
    {
      "disabled": false,
      "id": "dots-studio/dots-3-note-preview:free",
      "label": "Dots 3 Note Preview",
      "name": "Dots 3 Note Preview",
      "value": "dots-studio/dots-3-note-preview:free"
    },
    {
      "disabled": false,
      "id": "nvidia/nemotron-3.5-lightning:free",
      "label": "Nemotron 3.5 Lightning",
      "name": "Nemotron 3.5 Lightning",
      "value": "nvidia/nemotron-3.5-lightning:free"
    },
    {
      "disabled": false,
      "id": "poolside/laguna-s-2.1:free",
      "label": "Laguna S 2.1",
      "name": "Laguna S 2.1",
      "value": "poolside/laguna-s-2.1:free"
    },
    {
      "disabled": false,
      "id": "nvidia/nemotron-3-ultra-550b-a55b:free",
      "label": "Nemotron 3 Ultra 550B A55B",
      "name": "Nemotron 3 Ultra 550B A55B",
      "value": "nvidia/nemotron-3-ultra-550b-a55b:free"
    },
    {
      "disabled": false,
      "id": "poolside/laguna-xs-2.1:free",
      "label": "Laguna Xs 2.1",
      "name": "Laguna Xs 2.1",
      "value": "poolside/laguna-xs-2.1:free"
    },
    {
      "disabled": false,
      "id": "cohere/north-mini-code:free",
      "label": "North Mini Code",
      "name": "North Mini Code",
      "value": "cohere/north-mini-code:free"
    },
    {
      "disabled": false,
      "id": "nvidia/nemotron-3.5-content-safety:free",
      "label": "Nemotron 3.5 Content Safety",
      "name": "Nemotron 3.5 Content Safety",
      "value": "nvidia/nemotron-3.5-content-safety:free"
    },
    {
      "disabled": false,
      "id": "deepseek/deepseek-r1-0528",
      "label": "[R] Deepseek R1 0528",
      "name": "[R] Deepseek R1 0528",
      "value": "deepseek/deepseek-r1-0528"
    },
    {
      "disabled": false,
      "id": "deepseek/deepseek-r1",
      "label": "[R] Deepseek R1",
      "name": "[R] Deepseek R1",
      "value": "deepseek/deepseek-r1"
    },
    {
      "disabled": false,
      "id": "openai/o3-mini",
      "label": "[R] O3 Mini",
      "name": "[R] O3 Mini",
      "value": "openai/o3-mini"
    },
    {
      "disabled": false,
      "id": "openai/o3",
      "label": "[R] O3",
      "name": "[R] O3",
      "value": "openai/o3"
    },
    {
      "disabled": false,
      "id": "openai/o1",
      "label": "[R] O1",
      "name": "[R] O1",
      "value": "openai/o1"
    },
    {
      "disabled": false,
      "id": "qwen/qwen-2.5-72b-instruct",
      "label": "Qwen 2.5 72B Instruct",
      "name": "Qwen 2.5 72B Instruct",
      "value": "qwen/qwen-2.5-72b-instruct"
    },
    {
      "disabled": false,
      "id": "openai/gpt-4o-mini",
      "label": "GPT 4O Mini",
      "name": "GPT 4O Mini",
      "value": "openai/gpt-4o-mini"
    },
    {
      "disabled": false,
      "id": "meta-llama/llama-3.3-70b-instruct",
      "label": "Llama 3.3 70B Instruct",
      "name": "Llama 3.3 70B Instruct",
      "value": "meta-llama/llama-3.3-70b-instruct"
    },
    {
      "disabled": false,
      "id": "qwen/qwen-plus",
      "label": "Qwen Plus",
      "name": "Qwen Plus",
      "value": "qwen/qwen-plus"
    },
    {
      "disabled": false,
      "id": "deepseek/deepseek-chat-v3.1",
      "label": "Deepseek Chat V3.1",
      "name": "Deepseek Chat V3.1",
      "value": "deepseek/deepseek-chat-v3.1"
    },
    {
      "disabled": false,
      "id": "deepseek/deepseek-v3.1-terminus",
      "label": "Deepseek V3.1 Terminus",
      "name": "Deepseek V3.1 Terminus",
      "value": "deepseek/deepseek-v3.1-terminus"
    },
    {
      "disabled": false,
      "id": "deepseek/deepseek-chat",
      "label": "Deepseek Chat",
      "name": "Deepseek Chat",
      "value": "deepseek/deepseek-chat"
    },
    {
      "disabled": false,
      "id": "moonshotai/kimi-k2",
      "label": "Kimi K2",
      "name": "Kimi K2",
      "value": "moonshotai/kimi-k2"
    },
    {
      "disabled": false,
      "id": "google/gemini-2.5-flash",
      "label": "Gemini 2.5 Flash",
      "name": "Gemini 2.5 Flash",
      "value": "google/gemini-2.5-flash"
    },
    {
      "disabled": false,
      "id": "qwen/qwen3-max",
      "label": "Qwen3 Max",
      "name": "Qwen3 Max",
      "value": "qwen/qwen3-max"
    },
    {
      "disabled": false,
      "id": "openai/gpt-4.1",
      "label": "GPT 4.1",
      "name": "GPT 4.1",
      "value": "openai/gpt-4.1"
    },
    {
      "disabled": false,
      "id": "google/gemini-2.5-pro",
      "label": "Gemini 2.5 Pro",
      "name": "Gemini 2.5 Pro",
      "value": "google/gemini-2.5-pro"
    },
    {
      "disabled": false,
      "id": "openai/gpt-5",
      "label": "GPT 5",
      "name": "GPT 5",
      "value": "openai/gpt-5"
    },
    {
      "disabled": false,
      "id": "openai/gpt-4o",
      "label": "GPT 4O",
      "name": "GPT 4O",
      "value": "openai/gpt-4o"
    },
    {
      "disabled": false,
      "id": "anthropic/claude-sonnet-4.5",
      "label": "Claude Sonnet 4.5",
      "name": "Claude Sonnet 4.5",
      "value": "anthropic/claude-sonnet-4.5"
    },
    {
      "disabled": false,
      "id": "anthropic/claude-sonnet-4",
      "label": "Claude Sonnet 4",
      "name": "Claude Sonnet 4",
      "value": "anthropic/claude-sonnet-4"
    },
    {
      "disabled": false,
      "id": "anthropic/claude-opus-4.1",
      "label": "Claude Opus 4.1",
      "name": "Claude Opus 4.1",
      "value": "anthropic/claude-opus-4.1"
    },
    {
      "disabled": false,
      "id": "openai/gpt-5-pro",
      "label": "GPT 5 Pro",
      "name": "GPT 5 Pro",
      "value": "openai/gpt-5-pro"
    },
    {
      "disabled": false,
      "id": "mistralai/mistral-large",
      "label": "Mistral Large",
      "name": "Mistral Large",
      "value": "mistralai/mistral-large"
    },
    {
      "disabled": false,
      "id": "google/gemini-2.5-flash-lite",
      "label": "Gemini 2.5 Flash Lite",
      "name": "Gemini 2.5 Flash Lite",
      "value": "google/gemini-2.5-flash-lite"
    },
    {
      "disabled": false,
      "id": "openai/gpt-4.1-nano",
      "label": "GPT 4.1 Nano",
      "name": "GPT 4.1 Nano",
      "value": "openai/gpt-4.1-nano"
    },
    {
      "disabled": false,
      "id": "z-ai/glm-4.6",
      "label": "Glm 4.6",
      "name": "Glm 4.6",
      "value": "z-ai/glm-4.6"
    },
    {
      "disabled": false,
      "id": "inclusionai/ling-3.1-flash",
      "label": "Ling 3.1 Flash",
      "name": "Ling 3.1 Flash",
      "value": "inclusionai/ling-3.1-flash"
    }
  ],
  "runpod": [
    {
      "disabled": false,
      "id": "qwen3-32b-awq",
      "label": "Qwen3 32B AWQ",
      "name": "Qwen3 32B AWQ",
      "value": "qwen3-32b-awq"
    },
    {
      "disabled": false,
      "id": "granite-4-0-h-small",
      "label": "IBM Granite 4.0 H Small",
      "name": "IBM Granite 4.0 H Small",
      "value": "granite-4-0-h-small"
    }
  ]
};

export const LANGUAGES: LanguageOption[] = [
  {
    "english_label": "Chinese (Mandarin)",
    "flag": "🇨🇳",
    "is_top_20": true,
    "label": "普通话",
    "region": "Asia",
    "value": "cmn"
  },
  {
    "english_label": "Spanish",
    "flag": "🇪🇸",
    "is_top_20": true,
    "label": "Español",
    "region": "Europe",
    "value": "es"
  },
  {
    "english_label": "English (US)",
    "flag": "🇺🇸",
    "is_top_20": true,
    "label": "English",
    "region": "North America",
    "value": "en-us"
  },
  {
    "english_label": "Hindi",
    "flag": "🇮🇳",
    "is_top_20": true,
    "label": "हिन्दी",
    "region": "Asia",
    "value": "hi"
  },
  {
    "english_label": "Arabic",
    "flag": "🇸🇦",
    "is_top_20": true,
    "label": "العربية",
    "region": "Middle East",
    "value": "ar"
  },
  {
    "english_label": "Bengali",
    "flag": "🇧🇩",
    "is_top_20": true,
    "label": "বাংলা",
    "region": "Asia",
    "value": "bn"
  },
  {
    "english_label": "Portuguese (Brazil)",
    "flag": "🇧🇷",
    "is_top_20": true,
    "label": "Português (Brasil)",
    "region": "South America",
    "value": "pt-br"
  },
  {
    "english_label": "Russian",
    "flag": "🇷🇺",
    "is_top_20": true,
    "label": "Русский",
    "region": "Europe/Asia",
    "value": "ru"
  },
  {
    "english_label": "Japanese",
    "flag": "🇯🇵",
    "is_top_20": true,
    "label": "日本語",
    "region": "Asia",
    "value": "ja"
  },
  {
    "english_label": "Punjabi",
    "flag": "🇮🇳",
    "is_top_20": true,
    "label": "ਪੰਜਾਬੀ",
    "region": "Asia",
    "value": "pa"
  },
  {
    "english_label": "German",
    "flag": "🇩🇪",
    "is_top_20": true,
    "label": "Deutsch",
    "region": "Europe",
    "value": "de"
  },
  {
    "english_label": "Indonesian",
    "flag": "🇮🇩",
    "is_top_20": true,
    "label": "Bahasa Indonesia",
    "region": "Asia",
    "value": "id"
  },
  {
    "english_label": "French",
    "flag": "🇫🇷",
    "is_top_20": true,
    "label": "Français",
    "region": "Europe",
    "value": "fr"
  },
  {
    "english_label": "Turkish",
    "flag": "🇹🇷",
    "is_top_20": true,
    "label": "Türkçe",
    "region": "Asia/Europe",
    "value": "tr"
  },
  {
    "english_label": "Korean",
    "flag": "🇰🇷",
    "is_top_20": true,
    "label": "한국어",
    "region": "Asia",
    "value": "ko"
  },
  {
    "english_label": "Telugu",
    "flag": "🇮🇳",
    "is_top_20": true,
    "label": "తెలుగు",
    "region": "Asia",
    "value": "te"
  },
  {
    "english_label": "Vietnamese (Northern)",
    "flag": "🇻🇳",
    "is_top_20": true,
    "label": "Tiếng Việt",
    "region": "Asia",
    "value": "vi"
  },
  {
    "english_label": "Tamil",
    "flag": "🇮🇳",
    "is_top_20": true,
    "label": "தமிழ்",
    "region": "Asia",
    "value": "ta"
  },
  {
    "english_label": "Italian",
    "flag": "🇮🇹",
    "is_top_20": true,
    "label": "Italiano",
    "region": "Europe",
    "value": "it"
  },
  {
    "english_label": "Urdu",
    "flag": "🇵🇰",
    "is_top_20": true,
    "label": "اردو",
    "region": "Asia",
    "value": "ur"
  },
  {
    "english_label": "Spanish (Latin America)",
    "flag": "🇲🇽",
    "is_top_20": false,
    "label": "Español (Latinoamérica)",
    "region": "Latin America",
    "value": "es-419"
  },
  {
    "english_label": "Catalan",
    "flag": "🇦🇩",
    "is_top_20": false,
    "label": "Català",
    "region": "Europe",
    "value": "ca"
  },
  {
    "english_label": "French (Belgium)",
    "flag": "🇧🇪",
    "is_top_20": false,
    "label": "Français (Belgique)",
    "region": "Europe",
    "value": "fr-be"
  },
  {
    "english_label": "French (Switzerland)",
    "flag": "🇨🇭",
    "is_top_20": false,
    "label": "Français (Suisse)",
    "region": "Europe",
    "value": "fr-ch"
  },
  {
    "english_label": "Romanian",
    "flag": "🇷🇴",
    "is_top_20": false,
    "label": "Română",
    "region": "Europe",
    "value": "ro"
  },
  {
    "english_label": "Aragonese",
    "flag": "🇪🇸",
    "is_top_20": false,
    "label": "Aragonés",
    "region": "Europe",
    "value": "an"
  },
  {
    "english_label": "Haitian Creole",
    "flag": "🇭🇹",
    "is_top_20": false,
    "label": "Kreyòl Ayisyen",
    "region": "Caribbean",
    "value": "ht"
  },
  {
    "english_label": "Papiamento",
    "flag": "🇦🇼",
    "is_top_20": false,
    "label": "Papiamentu",
    "region": "Caribbean",
    "value": "pap"
  },
  {
    "english_label": "English (UK)",
    "flag": "🇬🇧",
    "is_top_20": false,
    "label": "English",
    "region": "Europe",
    "value": "en-gb"
  },
  {
    "english_label": "English (Caribbean)",
    "flag": "🇯🇲",
    "is_top_20": false,
    "label": "English",
    "region": "Caribbean",
    "value": "en-029"
  },
  {
    "english_label": "English (Scotland)",
    "flag": "",
    "is_top_20": false,
    "label": "English (Scotland)",
    "region": "Europe",
    "value": "en-gb-scotland"
  },
  {
    "english_label": "English (Lancaster)",
    "flag": "🇬🇧",
    "is_top_20": false,
    "label": "English",
    "region": "Europe",
    "value": "en-gb-x-gbclan"
  },
  {
    "english_label": "English (West Midlands)",
    "flag": "🇬🇧",
    "is_top_20": false,
    "label": "English",
    "region": "Europe",
    "value": "en-gb-x-gbcwmd"
  },
  {
    "english_label": "English (Received Pronunciation)",
    "flag": "🇬🇧",
    "is_top_20": false,
    "label": "English",
    "region": "Europe",
    "value": "en-gb-x-rp"
  },
  {
    "english_label": "Dutch",
    "flag": "🇳🇱",
    "is_top_20": false,
    "label": "Nederlands",
    "region": "Europe",
    "value": "nl"
  },
  {
    "english_label": "Afrikaans",
    "flag": "🇿🇦",
    "is_top_20": false,
    "label": "Afrikaans",
    "region": "Africa",
    "value": "af"
  },
  {
    "english_label": "Danish",
    "flag": "🇩🇰",
    "is_top_20": false,
    "label": "Dansk",
    "region": "Europe",
    "value": "da"
  },
  {
    "english_label": "Icelandic",
    "flag": "🇮🇸",
    "is_top_20": false,
    "label": "Íslenska",
    "region": "Europe",
    "value": "is"
  },
  {
    "english_label": "Norwegian Bokmål",
    "flag": "🇳🇴",
    "is_top_20": false,
    "label": "Norsk bokmål",
    "region": "Europe",
    "value": "nb"
  },
  {
    "english_label": "Swedish",
    "flag": "🇸🇪",
    "is_top_20": false,
    "label": "Svenska",
    "region": "Europe",
    "value": "sv"
  },
  {
    "english_label": "Bulgarian",
    "flag": "🇧🇬",
    "is_top_20": false,
    "label": "Български",
    "region": "Europe",
    "value": "bg"
  },
  {
    "english_label": "Bosnian",
    "flag": "🇧🇦",
    "is_top_20": false,
    "label": "Bosanski",
    "region": "Europe",
    "value": "bs"
  },
  {
    "english_label": "Czech",
    "flag": "🇨🇿",
    "is_top_20": false,
    "label": "Čeština",
    "region": "Europe",
    "value": "cs"
  },
  {
    "english_label": "Croatian",
    "flag": "🇭🇷",
    "is_top_20": false,
    "label": "Hrvatski",
    "region": "Europe",
    "value": "hr"
  },
  {
    "english_label": "Macedonian",
    "flag": "🇲🇰",
    "is_top_20": false,
    "label": "Македонски",
    "region": "Europe",
    "value": "mk"
  },
  {
    "english_label": "Polish",
    "flag": "🇵🇱",
    "is_top_20": false,
    "label": "Polski",
    "region": "Europe",
    "value": "pl"
  },
  {
    "english_label": "Russian (Latvia)",
    "flag": "🇱🇻",
    "is_top_20": false,
    "label": "Русский (Латвия)",
    "region": "Europe",
    "value": "ru-lv"
  },
  {
    "english_label": "Slovak",
    "flag": "🇸🇰",
    "is_top_20": false,
    "label": "Slovenčina",
    "region": "Europe",
    "value": "sk"
  },
  {
    "english_label": "Slovenian",
    "flag": "🇸🇮",
    "is_top_20": false,
    "label": "Slovenščina",
    "region": "Europe",
    "value": "sl"
  },
  {
    "english_label": "Serbian",
    "flag": "🇷🇸",
    "is_top_20": false,
    "label": "Српски",
    "region": "Europe",
    "value": "sr"
  },
  {
    "english_label": "Chinese (Cantonese)",
    "flag": "🇭🇰",
    "is_top_20": false,
    "label": "粵語",
    "region": "Asia",
    "value": "yue"
  },
  {
    "english_label": "Chinese (Hakka)",
    "flag": "🇨🇳",
    "is_top_20": false,
    "label": "客家话",
    "region": "Asia",
    "value": "hak"
  },
  {
    "english_label": "Vietnamese (Central)",
    "flag": "🇻🇳",
    "is_top_20": false,
    "label": "Tiếng Việt (Miền Trung)",
    "region": "Asia",
    "value": "vi-vn-x-central"
  },
  {
    "english_label": "Vietnamese (Southern)",
    "flag": "🇻🇳",
    "is_top_20": false,
    "label": "Tiếng Việt (Miền Nam)",
    "region": "Asia",
    "value": "vi-vn-x-south"
  },
  {
    "english_label": "Shan (Tai Yai)",
    "flag": "🇲🇲",
    "is_top_20": false,
    "label": "လိၵ်ႈတႆး",
    "region": "Asia",
    "value": "shn"
  },
  {
    "english_label": "Burmese",
    "flag": "🇲🇲",
    "is_top_20": false,
    "label": "မြန်မာ",
    "region": "Asia",
    "value": "my"
  },
  {
    "english_label": "Malay",
    "flag": "🇲🇾",
    "is_top_20": false,
    "label": "Bahasa Melayu",
    "region": "Asia",
    "value": "ms"
  },
  {
    "english_label": "Assamese",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "অসমীয়া",
    "region": "Asia",
    "value": "as"
  },
  {
    "english_label": "Bishnupriya Manipuri",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "বিষ্ণুপ্রিয়া মণিপুরী",
    "region": "Asia",
    "value": "bpy"
  },
  {
    "english_label": "Gujarati",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "ગુજરાતી",
    "region": "Asia",
    "value": "gu"
  },
  {
    "english_label": "Konkani",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "कोंकणी",
    "region": "Asia",
    "value": "kok"
  },
  {
    "english_label": "Marathi",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "मराठी",
    "region": "Asia",
    "value": "mr"
  },
  {
    "english_label": "Nepali",
    "flag": "🇳🇵",
    "is_top_20": false,
    "label": "नेपाली",
    "region": "Asia",
    "value": "ne"
  },
  {
    "english_label": "Odia",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "ଓଡ଼ିଆ",
    "region": "Asia",
    "value": "or"
  },
  {
    "english_label": "Sindhi",
    "flag": "🇵🇰",
    "is_top_20": false,
    "label": "سنڌي",
    "region": "Asia",
    "value": "sd"
  },
  {
    "english_label": "Sinhala",
    "flag": "🇱🇰",
    "is_top_20": false,
    "label": "සිංහල",
    "region": "Asia",
    "value": "si"
  },
  {
    "english_label": "Kannada",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "ಕನ್ನಡ",
    "region": "Asia",
    "value": "kn"
  },
  {
    "english_label": "Malayalam",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "മലയാളം",
    "region": "Asia",
    "value": "ml"
  },
  {
    "english_label": "Amharic",
    "flag": "🇪🇹",
    "is_top_20": false,
    "label": "አማርኛ",
    "region": "Africa",
    "value": "am"
  },
  {
    "english_label": "Maltese",
    "flag": "🇲🇹",
    "is_top_20": false,
    "label": "Malti",
    "region": "Europe",
    "value": "mt"
  },
  {
    "english_label": "Azerbaijani",
    "flag": "🇦🇿",
    "is_top_20": false,
    "label": "Azərbaycan",
    "region": "Asia",
    "value": "az"
  },
  {
    "english_label": "Bashkir",
    "flag": "🇷🇺",
    "is_top_20": false,
    "label": "Башҡорт",
    "region": "Asia",
    "value": "ba"
  },
  {
    "english_label": "Kazakh",
    "flag": "🇰🇿",
    "is_top_20": false,
    "label": "Қазақ",
    "region": "Asia",
    "value": "kk"
  },
  {
    "english_label": "Kyrgyz",
    "flag": "🇰🇬",
    "is_top_20": false,
    "label": "Кыргызча",
    "region": "Asia",
    "value": "ky"
  },
  {
    "english_label": "Tatar",
    "flag": "🇷🇺",
    "is_top_20": false,
    "label": "Татар",
    "region": "Asia",
    "value": "tt"
  },
  {
    "english_label": "Uzbek",
    "flag": "🇺🇿",
    "is_top_20": false,
    "label": "Oʻzbek",
    "region": "Asia",
    "value": "uz"
  },
  {
    "english_label": "Persian",
    "flag": "🇮🇷",
    "is_top_20": false,
    "label": "فارسی",
    "region": "Middle East",
    "value": "fa"
  },
  {
    "english_label": "Persian (Pinglish)",
    "flag": "🇮🇷",
    "is_top_20": false,
    "label": "Farsi (Latin)",
    "region": "Middle East",
    "value": "fa-latn"
  },
  {
    "english_label": "Kurdish",
    "flag": "🇮🇶",
    "is_top_20": false,
    "label": "Kurdî",
    "region": "Middle East",
    "value": "ku"
  },
  {
    "english_label": "Welsh",
    "flag": "",
    "is_top_20": false,
    "label": "Cymraeg",
    "region": "Europe",
    "value": "cy"
  },
  {
    "english_label": "Irish",
    "flag": "🇮🇪",
    "is_top_20": false,
    "label": "Gaeilge",
    "region": "Europe",
    "value": "ga"
  },
  {
    "english_label": "Scottish Gaelic",
    "flag": "",
    "is_top_20": false,
    "label": "Gàidhlig",
    "region": "Europe",
    "value": "gd"
  },
  {
    "english_label": "Lithuanian",
    "flag": "🇱🇹",
    "is_top_20": false,
    "label": "Lietuvių",
    "region": "Europe",
    "value": "lt"
  },
  {
    "english_label": "Latvian",
    "flag": "🇱🇻",
    "is_top_20": false,
    "label": "Latviešu",
    "region": "Europe",
    "value": "lv"
  },
  {
    "english_label": "Estonian",
    "flag": "🇪🇪",
    "is_top_20": false,
    "label": "Eesti",
    "region": "Europe",
    "value": "et"
  },
  {
    "english_label": "Finnish",
    "flag": "🇫🇮",
    "is_top_20": false,
    "label": "Suomi",
    "region": "Europe",
    "value": "fi"
  },
  {
    "english_label": "Hungarian",
    "flag": "🇭🇺",
    "is_top_20": false,
    "label": "Magyar",
    "region": "Europe",
    "value": "hu"
  },
  {
    "english_label": "Greenlandic",
    "flag": "🇬🇱",
    "is_top_20": false,
    "label": "Kalaallisut",
    "region": "North America",
    "value": "kl"
  },
  {
    "english_label": "K'iche'",
    "flag": "🇬🇹",
    "is_top_20": false,
    "label": "K'iche'",
    "region": "North America",
    "value": "quc"
  },
  {
    "english_label": "Guarani",
    "flag": "",
    "is_top_20": false,
    "label": "Avañe'ẽ",
    "region": "South America",
    "value": "gn"
  },
  {
    "english_label": "Tupi",
    "flag": "",
    "is_top_20": false,
    "label": "Nheengatu",
    "region": "South America",
    "value": "tpw"
  },
  {
    "english_label": "Greek",
    "flag": "🇬🇷",
    "is_top_20": false,
    "label": "Ελληνικά",
    "region": "Europe",
    "value": "el"
  },
  {
    "english_label": "Ancient Greek",
    "flag": "",
    "is_top_20": false,
    "label": "Ἑλληνική",
    "region": "Historical",
    "value": "grc"
  },
  {
    "english_label": "Albanian",
    "flag": "🇦🇱",
    "is_top_20": false,
    "label": "Shqip",
    "region": "Europe",
    "value": "sq"
  },
  {
    "english_label": "Armenian",
    "flag": "🇦🇲",
    "is_top_20": false,
    "label": "Հայերեն",
    "region": "Asia",
    "value": "hy"
  },
  {
    "english_label": "Armenian (West Armenia)",
    "flag": "🇦🇲",
    "is_top_20": false,
    "label": "Արեւմտահայերէն",
    "region": "Asia",
    "value": "hyw"
  },
  {
    "english_label": "Latin",
    "flag": "",
    "is_top_20": false,
    "label": "Latina",
    "region": "Historical",
    "value": "la"
  },
  {
    "english_label": "Georgian",
    "flag": "🇬🇪",
    "is_top_20": false,
    "label": "ქართული",
    "region": "Asia",
    "value": "ka"
  },
  {
    "english_label": "Swahili",
    "flag": "🇰🇪",
    "is_top_20": false,
    "label": "Kiswahili",
    "region": "Africa",
    "value": "sw"
  },
  {
    "english_label": "Tswana",
    "flag": "🇧🇼",
    "is_top_20": false,
    "label": "Setswana",
    "region": "Africa",
    "value": "tn"
  },
  {
    "english_label": "Oromo",
    "flag": "🇪🇹",
    "is_top_20": false,
    "label": "Oromoo",
    "region": "Africa",
    "value": "om"
  },
  {
    "english_label": "Maori",
    "flag": "🇳🇿",
    "is_top_20": false,
    "label": "Te Reo Māori",
    "region": "Oceania",
    "value": "mi"
  },
  {
    "english_label": "Nahuatl",
    "flag": "🇲🇽",
    "is_top_20": false,
    "label": "Nāhuatl",
    "region": "North America",
    "value": "nci"
  },
  {
    "english_label": "Lingua Franca Nova",
    "flag": "",
    "is_top_20": false,
    "label": "Lingua Franca Nova",
    "region": "Constructed",
    "value": "lfn"
  },
  {
    "english_label": "Esperanto",
    "flag": "",
    "is_top_20": false,
    "label": "Esperanto",
    "region": "Constructed",
    "value": "eo"
  },
  {
    "english_label": "Interlingua",
    "flag": "",
    "is_top_20": false,
    "label": "Interlingua",
    "region": "Constructed",
    "value": "ia"
  },
  {
    "english_label": "Lojban",
    "flag": "",
    "is_top_20": false,
    "label": "Lojban",
    "region": "Constructed",
    "value": "jbo"
  },
  {
    "english_label": "Chinese (Simplified)",
    "flag": "🇨🇳",
    "is_top_20": false,
    "label": "简体中文",
    "region": "Asia",
    "value": "zh"
  },
  {
    "english_label": "Norwegian",
    "flag": "🇳🇴",
    "is_top_20": false,
    "label": "Norsk",
    "region": "Europe",
    "value": "no"
  },
  {
    "english_label": "Belarusian",
    "flag": "🇧🇾",
    "is_top_20": false,
    "label": "Беларуская",
    "region": "Europe",
    "value": "be"
  },
  {
    "english_label": "Corsican",
    "flag": "🇫🇷",
    "is_top_20": false,
    "label": "Corsu",
    "region": "Europe",
    "value": "co"
  },
  {
    "english_label": "Basque",
    "flag": "🇪🇸",
    "is_top_20": false,
    "label": "Euskara",
    "region": "Europe",
    "value": "eu"
  },
  {
    "english_label": "Western Frisian",
    "flag": "🇳🇱",
    "is_top_20": false,
    "label": "Frysk",
    "region": "Europe",
    "value": "fy"
  },
  {
    "english_label": "Friulian",
    "flag": "🇮🇹",
    "is_top_20": false,
    "label": "Furlan",
    "region": "Europe",
    "value": "fur"
  },
  {
    "english_label": "Galician",
    "flag": "🇪🇸",
    "is_top_20": false,
    "label": "Galego",
    "region": "Europe",
    "value": "gl"
  },
  {
    "english_label": "Luxembourgish",
    "flag": "🇱🇺",
    "is_top_20": false,
    "label": "Lëtzebuergesch",
    "region": "Europe",
    "value": "lb"
  },
  {
    "english_label": "Lombard",
    "flag": "🇮🇹",
    "is_top_20": false,
    "label": "Lumbaart",
    "region": "Europe",
    "value": "lmo"
  },
  {
    "english_label": "Latgalian",
    "flag": "🇱🇻",
    "is_top_20": false,
    "label": "Latgalīšu",
    "region": "Europe",
    "value": "ltg"
  },
  {
    "english_label": "Sicilian",
    "flag": "🇮🇹",
    "is_top_20": false,
    "label": "Sicilianu",
    "region": "Europe",
    "value": "scn"
  },
  {
    "english_label": "Silesian",
    "flag": "🇵🇱",
    "is_top_20": false,
    "label": "Ślōnski",
    "region": "Europe",
    "value": "szl"
  },
  {
    "english_label": "Ukrainian",
    "flag": "🇺🇦",
    "is_top_20": false,
    "label": "Українська",
    "region": "Europe",
    "value": "uk"
  },
  {
    "english_label": "Venetian",
    "flag": "🇮🇹",
    "is_top_20": false,
    "label": "Vèneto",
    "region": "Europe",
    "value": "vec"
  },
  {
    "english_label": "Yiddish",
    "flag": "🇮🇱",
    "is_top_20": false,
    "label": "ייִדיש",
    "region": "Europe",
    "value": "yi"
  },
  {
    "english_label": "Acehnese",
    "flag": "🇮🇩",
    "is_top_20": false,
    "label": "Bahsa Acèh",
    "region": "Asia",
    "value": "ace"
  },
  {
    "english_label": "Aymara",
    "flag": "🇧🇴",
    "is_top_20": false,
    "label": "Aymar aru",
    "region": "South America",
    "value": "ay"
  },
  {
    "english_label": "Balinese",
    "flag": "🇮🇩",
    "is_top_20": false,
    "label": "ᬩᬲᬩᬮᬶ",
    "region": "Asia",
    "value": "ban"
  },
  {
    "english_label": "Bhojpuri",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "भोजपुरी",
    "region": "Asia",
    "value": "bho"
  },
  {
    "english_label": "Banjar",
    "flag": "🇮🇩",
    "is_top_20": false,
    "label": "Bahasa Banjar",
    "region": "Asia",
    "value": "bjn"
  },
  {
    "english_label": "Buginese",
    "flag": "🇮🇩",
    "is_top_20": false,
    "label": "ᨅᨔ ᨕᨘᨁᨗ",
    "region": "Asia",
    "value": "bug"
  },
  {
    "english_label": "Cebuano",
    "flag": "🇵🇭",
    "is_top_20": false,
    "label": "Sinugbuanon",
    "region": "Asia",
    "value": "ceb"
  },
  {
    "english_label": "Dhivehi",
    "flag": "🇲🇻",
    "is_top_20": false,
    "label": "ދިވެހި",
    "region": "Asia",
    "value": "dv"
  },
  {
    "english_label": "Ilocano",
    "flag": "🇵🇭",
    "is_top_20": false,
    "label": "Ilokano",
    "region": "Asia",
    "value": "ilo"
  },
  {
    "english_label": "Hebrew",
    "flag": "🇮🇱",
    "is_top_20": false,
    "label": "עברית",
    "region": "Middle East",
    "value": "iw"
  },
  {
    "english_label": "Javanese",
    "flag": "🇮🇩",
    "is_top_20": false,
    "label": "ꦧꦱꦗꦮ",
    "region": "Asia",
    "value": "jv"
  },
  {
    "english_label": "Kashmiri",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "कॉशुर",
    "region": "Asia",
    "value": "kas"
  },
  {
    "english_label": "Khmer",
    "flag": "🇰🇭",
    "is_top_20": false,
    "label": "ភាសាខ្មែរ",
    "region": "Asia",
    "value": "km"
  },
  {
    "english_label": "Lao",
    "flag": "🇱🇦",
    "is_top_20": false,
    "label": "ລາວ",
    "region": "Asia",
    "value": "lo"
  },
  {
    "english_label": "Maithili",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "मैथिली",
    "region": "Asia",
    "value": "mai"
  },
  {
    "english_label": "Minangkabau",
    "flag": "🇮🇩",
    "is_top_20": false,
    "label": "Minangkabau",
    "region": "Asia",
    "value": "min"
  },
  {
    "english_label": "Mongolian",
    "flag": "🇲🇳",
    "is_top_20": false,
    "label": "Монгол",
    "region": "Asia",
    "value": "mn"
  },
  {
    "english_label": "Meiteilon (Manipuri)",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "মৈতৈলোন্",
    "region": "Asia",
    "value": "mni-mtei"
  },
  {
    "english_label": "Pangasinan",
    "flag": "🇵🇭",
    "is_top_20": false,
    "label": "Salitan Pangasinan",
    "region": "Asia",
    "value": "pag"
  },
  {
    "english_label": "Pashto",
    "flag": "🇦🇫",
    "is_top_20": false,
    "label": "پښتو",
    "region": "Middle East",
    "value": "ps"
  },
  {
    "english_label": "Quechua",
    "flag": "🇵🇪",
    "is_top_20": false,
    "label": "Runa Simi",
    "region": "South America",
    "value": "qu"
  },
  {
    "english_label": "Sanskrit",
    "flag": "🇮🇳",
    "is_top_20": false,
    "label": "संस्कृतम्",
    "region": "Asia",
    "value": "sa"
  },
  {
    "english_label": "Sundanese",
    "flag": "🇮🇩",
    "is_top_20": false,
    "label": "ᮘᮞ ᮞᮥᮔ᮪ᮓ",
    "region": "Asia",
    "value": "su"
  },
  {
    "english_label": "Tajik",
    "flag": "🇹🇯",
    "is_top_20": false,
    "label": "Тоҷикӣ",
    "region": "Asia",
    "value": "tg"
  },
  {
    "english_label": "Thai",
    "flag": "🇹🇭",
    "is_top_20": false,
    "label": "ไทย",
    "region": "Asia",
    "value": "th"
  },
  {
    "english_label": "Turkmen",
    "flag": "🇹🇲",
    "is_top_20": false,
    "label": "Türkmençe",
    "region": "Asia",
    "value": "tk"
  },
  {
    "english_label": "Tagalog",
    "flag": "🇵🇭",
    "is_top_20": false,
    "label": "Tagalog",
    "region": "Asia",
    "value": "tl"
  },
  {
    "english_label": "Uyghur",
    "flag": "🇨🇳",
    "is_top_20": false,
    "label": "ئۇيغۇرچە",
    "region": "Asia",
    "value": "ug"
  },
  {
    "english_label": "Waray",
    "flag": "🇵🇭",
    "is_top_20": false,
    "label": "Winaray",
    "region": "Asia",
    "value": "war"
  },
  {
    "english_label": "Bambara",
    "flag": "🇲🇱",
    "is_top_20": false,
    "label": "Bamanankan",
    "region": "Africa",
    "value": "bm"
  },
  {
    "english_label": "Ewe",
    "flag": "🇬🇭",
    "is_top_20": false,
    "label": "Eʋegbe",
    "region": "Africa",
    "value": "ee"
  },
  {
    "english_label": "Hausa",
    "flag": "🇳🇬",
    "is_top_20": false,
    "label": "Hausa",
    "region": "Africa",
    "value": "ha"
  },
  {
    "english_label": "Igbo",
    "flag": "🇳🇬",
    "is_top_20": false,
    "label": "Igbo",
    "region": "Africa",
    "value": "ig"
  },
  {
    "english_label": "Kabyle",
    "flag": "🇩🇿",
    "is_top_20": false,
    "label": "Taqbaylit",
    "region": "Africa",
    "value": "kab"
  },
  {
    "english_label": "Kamba",
    "flag": "🇰🇪",
    "is_top_20": false,
    "label": "Kikamba",
    "region": "Africa",
    "value": "kam"
  },
  {
    "english_label": "Central Kanuri",
    "flag": "🇳🇬",
    "is_top_20": false,
    "label": "Kanuri",
    "region": "Africa",
    "value": "knc"
  },
  {
    "english_label": "Krio",
    "flag": "🇸🇱",
    "is_top_20": false,
    "label": "Krio",
    "region": "Africa",
    "value": "kri"
  },
  {
    "english_label": "Luganda",
    "flag": "🇺🇬",
    "is_top_20": false,
    "label": "Luganda",
    "region": "Africa",
    "value": "lg"
  },
  {
    "english_label": "Lingala",
    "flag": "🇨🇩",
    "is_top_20": false,
    "label": "Lingála",
    "region": "Africa",
    "value": "ln"
  },
  {
    "english_label": "Luo",
    "flag": "🇰🇪",
    "is_top_20": false,
    "label": "Dholuo",
    "region": "Africa",
    "value": "luo"
  },
  {
    "english_label": "Malagasy",
    "flag": "🇲🇬",
    "is_top_20": false,
    "label": "Malagasy",
    "region": "Africa",
    "value": "mg"
  },
  {
    "english_label": "Nuer",
    "flag": "🇸🇸",
    "is_top_20": false,
    "label": "Thok Naath",
    "region": "Africa",
    "value": "nus"
  },
  {
    "english_label": "Chichewa",
    "flag": "🇲🇼",
    "is_top_20": false,
    "label": "Chicheŵa",
    "region": "Africa",
    "value": "ny"
  },
  {
    "english_label": "Kinyarwanda",
    "flag": "🇷🇼",
    "is_top_20": false,
    "label": "Ikinyarwanda",
    "region": "Africa",
    "value": "rw"
  },
  {
    "english_label": "Samoan",
    "flag": "🇼🇸",
    "is_top_20": false,
    "label": "Gagana Samoa",
    "region": "Oceania",
    "value": "sm"
  },
  {
    "english_label": "Shona",
    "flag": "🇿🇼",
    "is_top_20": false,
    "label": "chiShona",
    "region": "Africa",
    "value": "sn"
  },
  {
    "english_label": "Somali",
    "flag": "🇸🇴",
    "is_top_20": false,
    "label": "Soomaali",
    "region": "Africa",
    "value": "so"
  },
  {
    "english_label": "Sesotho",
    "flag": "🇱🇸",
    "is_top_20": false,
    "label": "Sesotho",
    "region": "Africa",
    "value": "st"
  },
  {
    "english_label": "Tamasheq",
    "flag": "🇲🇱",
    "is_top_20": false,
    "label": "Tamashek",
    "region": "Africa",
    "value": "taq"
  },
  {
    "english_label": "Tigrinya",
    "flag": "🇪🇷",
    "is_top_20": false,
    "label": "ትግርኛ",
    "region": "Africa",
    "value": "ti"
  },
  {
    "english_label": "Tsonga",
    "flag": "🇿🇦",
    "is_top_20": false,
    "label": "Xitsonga",
    "region": "Africa",
    "value": "ts"
  },
  {
    "english_label": "Xhosa",
    "flag": "🇿🇦",
    "is_top_20": false,
    "label": "isiXhosa",
    "region": "Africa",
    "value": "xh"
  },
  {
    "english_label": "Yoruba",
    "flag": "🇳🇬",
    "is_top_20": false,
    "label": "Yorùbá",
    "region": "Africa",
    "value": "yo"
  },
  {
    "english_label": "Zulu",
    "flag": "🇿🇦",
    "is_top_20": false,
    "label": "isiZulu",
    "region": "Africa",
    "value": "zu"
  },
  {
    "english_label": "Crimean Tatar",
    "flag": "🇺🇦",
    "is_top_20": false,
    "label": "Qırımtatarca",
    "region": "Europe",
    "value": "crh"
  },
  {
    "english_label": "Hawaiian",
    "flag": "🇺🇸",
    "is_top_20": false,
    "label": "ʻŌlelo Hawaiʻi",
    "region": "Oceania",
    "value": "haw"
  }
];

export const RESOLUTIONS: ResolutionOption[] = [
  {
    "aspect_ratio": "16:9",
    "label": "1920x1080 (Full HD Horizontal 16:9)",
    "orientation": "horizontal",
    "short_label": "1080p",
    "value": "1920x1080",
    "width": 1920,
    "height": 1080
  },
  {
    "aspect_ratio": "16:9",
    "label": "1280x720 (HD Horizontal 16:9)",
    "orientation": "horizontal",
    "short_label": "720p",
    "value": "1280x720",
    "width": 1280,
    "height": 720
  },
  {
    "aspect_ratio": "9:16",
    "label": "1080x1920 (Full HD Vertical 9:16 - TikTok/Reels)",
    "orientation": "vertical",
    "short_label": "1080p Vertical",
    "value": "1080x1920",
    "width": 1080,
    "height": 1920
  },
  {
    "aspect_ratio": "9:16",
    "label": "720x1280 (HD Vertical 9:16 - TikTok/Reels)",
    "orientation": "vertical",
    "short_label": "720p Vertical",
    "value": "720x1280",
    "width": 720,
    "height": 1280
  },
  {
    "aspect_ratio": "1:1",
    "label": "1080x1080 (Square Full HD 1:1 - Instagram)",
    "orientation": "square",
    "short_label": "1080p Square",
    "value": "1080x1080",
    "width": 1080,
    "height": 1080
  },
  {
    "aspect_ratio": "1:1",
    "label": "720x720 (Square HD 1:1 - Instagram)",
    "orientation": "square",
    "short_label": "720p Square",
    "value": "720x720",
    "width": 720,
    "height": 720
  },
  {
    "aspect_ratio": "1:1",
    "label": "512x512 (SD Square 1:1)",
    "orientation": "square",
    "short_label": "512 Square",
    "value": "512x512",
    "width": 512,
    "height": 512
  },
  {
    "aspect_ratio": "16:9",
    "label": "912x512 (SD Horizontal 16:9)",
    "orientation": "horizontal",
    "short_label": "512p",
    "value": "912x512",
    "width": 912,
    "height": 512
  },
  {
    "aspect_ratio": "9:16",
    "label": "512x912 (SD Vertical 9:16)",
    "orientation": "vertical",
    "short_label": "512p Vertical",
    "value": "512x912",
    "width": 512,
    "height": 912
  },
  {
    "aspect_ratio": "16:9",
    "label": "3840x2160 (4K UHD Horizontal 16:9)",
    "orientation": "horizontal",
    "premium": true,
    "short_label": "4K",
    "value": "3840x2160",
    "width": 3840,
    "height": 2160
  }
];

export const VIDEO_RESOLUTIONS = RESOLUTIONS; // Alias for backward compatibility

export const VIDEO_STYLES: StyleOption[] = [
  {
    "description": "Professional and corporate style for business presentations",
    "label": "Professional",
    "value": "professional"
  },
  {
    "description": "Uplifting and inspirational style for motivational content",
    "label": "Inspirational",
    "value": "inspirational"
  },
  {
    "description": "Serious documentary style for historical or educational content",
    "label": "Documentary",
    "value": "documentary"
  },
  {
    "description": "Modern technology style for product demos and tech content",
    "label": "Tech",
    "value": "tech"
  },
  {
    "description": "Clear educational style for tutorials and learning content",
    "label": "Educational",
    "value": "educational"
  },
  {
    "description": "Dramatic cinematic style for storytelling and trailers",
    "label": "Cinematic",
    "value": "cinematic"
  },
  {
    "description": "Clean minimalist style for elegant presentations",
    "label": "Minimalist",
    "value": "minimalist"
  },
  {
    "description": "Fun and colorful style for children's content",
    "label": "Kids",
    "value": "kids"
  },
  {
    "description": "Professional news style for reports and journalism",
    "label": "News",
    "value": "news"
  },
  {
    "description": "Creative artistic style for cultural and creative content",
    "label": "Artistic",
    "value": "artistic"
  },
  {
    "description": "Fast-paced and energetic style for action-packed content",
    "label": "Dynamic",
    "value": "dynamic"
  },
  {
    "description": "Dramatic style for emotional and impactful storytelling",
    "label": "Dramatic",
    "value": "dramatic"
  },
  {
    "description": "Promotional style for marketing and advertising content",
    "label": "Promotional",
    "value": "promotional"
  },
  {
    "description": "High-energy style with vibrant visuals and fast pace",
    "label": "Energetic",
    "value": "energetic"
  }
];

export const DURATION_OPTIONS: DurationOption[] = [
  {
    "label": "15 seconds",
    "premium": false,
    "seconds": 15,
    "value": 0.25,
    "disabled": false
  },
  {
    "label": "30 seconds",
    "premium": false,
    "seconds": 30,
    "value": 0.5,
    "disabled": false
  },
  {
    "label": "45 seconds",
    "premium": false,
    "seconds": 45,
    "value": 0.75,
    "disabled": false
  },
  {
    "label": "1 minute",
    "premium": false,
    "seconds": 60,
    "value": 1,
    "disabled": false
  },
  {
    "label": "1.5 minutes",
    "premium": false,
    "seconds": 90,
    "value": 1.5,
    "disabled": false
  },
  {
    "label": "2 minutes",
    "premium": false,
    "seconds": 120,
    "value": 2,
    "disabled": false
  },
  {
    "label": "3 minutes",
    "premium": false,
    "seconds": 180,
    "value": 3,
    "disabled": false
  },
  {
    "label": "5 minutes",
    "premium": false,
    "seconds": 300,
    "value": 5,
    "disabled": false
  },
  {
    "disabled": true,
    "label": "10 minutes",
    "premium": true,
    "seconds": 600,
    "value": 10
  },
  {
    "disabled": true,
    "label": "15 minutes",
    "premium": true,
    "seconds": 900,
    "value": 15
  },
  {
    "disabled": true,
    "label": "20 minutes",
    "premium": true,
    "seconds": 1200,
    "value": 20
  },
  {
    "disabled": true,
    "label": "30 minutes",
    "premium": true,
    "seconds": 1800,
    "value": 30
  },
  {
    "disabled": true,
    "label": "45 minutes",
    "premium": true,
    "seconds": 2700,
    "value": 45
  },
  {
    "disabled": true,
    "label": "1 hour",
    "premium": true,
    "seconds": 3600,
    "value": 60
  },
  {
    "disabled": true,
    "label": "1.5 hours",
    "premium": true,
    "seconds": 5400,
    "value": 90
  },
  {
    "disabled": true,
    "label": "2 hours",
    "premium": true,
    "seconds": 7200,
    "value": 120
  },
  {
    "disabled": true,
    "label": "3 hours",
    "premium": true,
    "seconds": 10800,
    "value": 180
  }
];

export const VOICE_OPTIONS: Record<string, Record<string, string[]>> = {
  "chatterbox": {
    "ar": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "cs": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "de": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "en": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "en-gb": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "en-us": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "es": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "fr": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "hi": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "id": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "it": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "ja": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "ko": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "nl": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "pl": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "pt": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "pt-br": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "ru": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "sv": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "th": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "tr": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "vi": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ],
    "zh": [
      "auto",
      "neutral",
      "happy",
      "sad",
      "angry",
      "surprised",
      "fearful",
      "disgusted",
      "clone_from_reference"
    ]
  },
  "chatterbox_turbo": {
    "ar": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "cs": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "de": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "en": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "en-gb": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "en-us": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "es": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "fr": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "hi": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "id": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "it": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "ja": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "ko": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "nl": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "pl": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "pt": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "pt-br": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "ru": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "sv": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "th": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "tr": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "vi": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ],
    "zh": [
      "lucy",
      "oliver",
      "nova",
      "aria",
      "echo"
    ]
  },
  "edge_tts": {
    "af": [
      "af-ZA-AdriNeural",
      "af-ZA-WillemNeural"
    ],
    "am": [
      "am-ET-MekdesNeural",
      "am-ET-AmehaNeural"
    ],
    "ar": [
      "ar-SA-ZariyahNeural",
      "ar-SA-HamedNeural"
    ],
    "ar-sa": [
      "ar-SA-ZariyahNeural",
      "ar-SA-HamedNeural"
    ],
    "az": [
      "az-AZ-BanuNeural",
      "az-AZ-BabekNeural"
    ],
    "bg": [
      "bg-BG-KalinaNeural",
      "bg-BG-BorislavNeural"
    ],
    "bn": [
      "bn-IN-TanishaaNeural",
      "bn-IN-BashkarNeural"
    ],
    "bn-in": [
      "bn-IN-TanishaaNeural",
      "bn-IN-BashkarNeural"
    ],
    "bs": [
      "bs-BA-VesnaNeural",
      "bs-BA-GoranNeural"
    ],
    "ca": [
      "ca-ES-JoanaNeural",
      "ca-ES-EnricNeural"
    ],
    "cs": [
      "cs-CZ-VlastaNeural",
      "cs-CZ-AntoninNeural"
    ],
    "cs-cz": [
      "cs-CZ-VlastaNeural",
      "cs-CZ-AntoninNeural"
    ],
    "cy": [
      "cy-GB-NiaNeural",
      "cy-GB-AledNeural"
    ],
    "da": [
      "da-DK-ChristelNeural",
      "da-DK-JeppeNeural"
    ],
    "da-dk": [
      "da-DK-ChristelNeural",
      "da-DK-JeppeNeural"
    ],
    "de": [
      "de-DE-KatjaNeural",
      "de-DE-ConradNeural"
    ],
    "de-at": [
      "de-AT-IngridNeural",
      "de-AT-JonasNeural"
    ],
    "de-de": [
      "de-DE-KatjaNeural",
      "de-DE-ConradNeural"
    ],
    "el": [
      "el-GR-AthinaNeural",
      "el-GR-NestorasNeural"
    ],
    "el-gr": [
      "el-GR-AthinaNeural",
      "el-GR-NestorasNeural"
    ],
    "en": [
      "en-US-AriaNeural",
      "en-US-GuyNeural"
    ],
    "en-au": [
      "en-AU-NatashaNeural",
      "en-AU-WilliamMultilingualNeural"
    ],
    "en-gb": [
      "en-GB-SoniaNeural",
      "en-GB-RyanNeural"
    ],
    "en-in": [
      "en-IN-NeerjaNeural",
      "en-IN-PrabhatNeural"
    ],
    "en-us": [
      "en-US-AriaNeural",
      "en-US-GuyNeural"
    ],
    "es": [
      "es-ES-ElviraNeural",
      "es-ES-AlvaroNeural"
    ],
    "es-ar": [
      "es-AR-ElenaNeural",
      "es-AR-TomasNeural"
    ],
    "es-es": [
      "es-ES-ElviraNeural",
      "es-ES-AlvaroNeural"
    ],
    "es-mx": [
      "es-MX-DaliaNeural",
      "es-MX-JorgeNeural"
    ],
    "et": [
      "et-EE-AnuNeural",
      "et-EE-KertNeural"
    ],
    "fa": [
      "fa-IR-DilaraNeural",
      "fa-IR-FaridNeural"
    ],
    "fa-ir": [
      "fa-IR-DilaraNeural",
      "fa-IR-FaridNeural"
    ],
    "fi": [
      "fi-FI-NooraNeural",
      "fi-FI-HarriNeural"
    ],
    "fi-fi": [
      "fi-FI-NooraNeural",
      "fi-FI-HarriNeural"
    ],
    "fil": [
      "fil-PH-BlessicaNeural",
      "fil-PH-AngeloNeural"
    ],
    "fil-ph": [
      "fil-PH-BlessicaNeural",
      "fil-PH-AngeloNeural"
    ],
    "fr": [
      "fr-FR-DeniseNeural",
      "fr-FR-HenriNeural"
    ],
    "fr-ca": [
      "fr-CA-SylvieNeural",
      "fr-CA-AntoineNeural"
    ],
    "fr-fr": [
      "fr-FR-DeniseNeural",
      "fr-FR-HenriNeural"
    ],
    "ga": [
      "ga-IE-OrlaNeural",
      "ga-IE-ColmNeural"
    ],
    "gl": [
      "gl-ES-SabelaNeural",
      "gl-ES-RoiNeural"
    ],
    "gu": [
      "gu-IN-DhwaniNeural",
      "gu-IN-NiranjanNeural"
    ],
    "gu-in": [
      "gu-IN-DhwaniNeural",
      "gu-IN-NiranjanNeural"
    ],
    "he": [
      "he-IL-HilaNeural",
      "he-IL-AvriNeural"
    ],
    "he-il": [
      "he-IL-HilaNeural",
      "he-IL-AvriNeural"
    ],
    "hi": [
      "hi-IN-SwaraNeural",
      "hi-IN-MadhurNeural"
    ],
    "hi-in": [
      "hi-IN-SwaraNeural",
      "hi-IN-MadhurNeural"
    ],
    "hr": [
      "hr-HR-GabrijelaNeural",
      "hr-HR-SreckoNeural"
    ],
    "hu": [
      "hu-HU-NoemiNeural",
      "hu-HU-TamasNeural"
    ],
    "hu-hu": [
      "hu-HU-NoemiNeural",
      "hu-HU-TamasNeural"
    ],
    "id": [
      "id-ID-GadisNeural",
      "id-ID-ArdiNeural"
    ],
    "id-id": [
      "id-ID-GadisNeural",
      "id-ID-ArdiNeural"
    ],
    "is": [
      "is-IS-GudrunNeural",
      "is-IS-GunnarNeural"
    ],
    "it": [
      "it-IT-ElsaNeural",
      "it-IT-DiegoNeural"
    ],
    "it-it": [
      "it-IT-ElsaNeural",
      "it-IT-DiegoNeural"
    ],
    "ja": [
      "ja-JP-NanamiNeural",
      "ja-JP-KeitaNeural"
    ],
    "ja-jp": [
      "ja-JP-NanamiNeural",
      "ja-JP-KeitaNeural"
    ],
    "jv": [
      "jv-ID-SitiNeural",
      "jv-ID-DimasNeural"
    ],
    "ka": [
      "ka-GE-EkaNeural",
      "ka-GE-GiorgiNeural"
    ],
    "kk": [
      "kk-KZ-AigulNeural",
      "kk-KZ-DauletNeural"
    ],
    "km": [
      "km-KH-SreymomNeural",
      "km-KH-PisethNeural"
    ],
    "kn": [
      "kn-IN-SapnaNeural",
      "kn-IN-GaganNeural"
    ],
    "kn-in": [
      "kn-IN-SapnaNeural",
      "kn-IN-GaganNeural"
    ],
    "ko": [
      "ko-KR-SunHiNeural",
      "ko-KR-InJoonNeural"
    ],
    "ko-kr": [
      "ko-KR-SunHiNeural",
      "ko-KR-HyunsuMultilingualNeural"
    ],
    "lo": [
      "lo-LA-KeomanyNeural",
      "lo-LA-ChanthavongNeural"
    ],
    "lt": [
      "lt-LT-OnaNeural",
      "lt-LT-LeonasNeural"
    ],
    "lv": [
      "lv-LV-EveritaNeural",
      "lv-LV-NilsNeural"
    ],
    "mk": [
      "mk-MK-MarijaNeural",
      "mk-MK-AleksandarNeural"
    ],
    "ml": [
      "ml-IN-SobhanaNeural",
      "ml-IN-MidhunNeural"
    ],
    "ml-in": [
      "ml-IN-SobhanaNeural",
      "ml-IN-MidhunNeural"
    ],
    "mn": [
      "mn-MN-YesuiNeural",
      "mn-MN-BataaNeural"
    ],
    "mr": [
      "mr-IN-AarohiNeural",
      "mr-IN-ManoharNeural"
    ],
    "mr-in": [
      "mr-IN-AarohiNeural",
      "mr-IN-ManoharNeural"
    ],
    "ms": [
      "ms-MY-YasminNeural",
      "ms-MY-OsmanNeural"
    ],
    "ms-my": [
      "ms-MY-YasminNeural",
      "ms-MY-OsmanNeural"
    ],
    "mt": [
      "mt-MT-GraceNeural",
      "mt-MT-JosephNeural"
    ],
    "my": [
      "my-MM-NilarNeural",
      "my-MM-ThihaNeural"
    ],
    "nb": [
      "nb-NO-PernilleNeural",
      "nb-NO-FinnNeural"
    ],
    "nb-no": [
      "nb-NO-PernilleNeural",
      "nb-NO-FinnNeural"
    ],
    "ne": [
      "ne-NP-HemkalaNeural",
      "ne-NP-SagarNeural"
    ],
    "nl": [
      "nl-NL-ColetteNeural",
      "nl-NL-MaartenNeural"
    ],
    "nl-nl": [
      "nl-NL-ColetteNeural",
      "nl-NL-MaartenNeural"
    ],
    "no": [
      "nb-NO-PernilleNeural",
      "nb-NO-FinnNeural"
    ],
    "pl": [
      "pl-PL-ZofiaNeural",
      "pl-PL-MarekNeural"
    ],
    "pl-pl": [
      "pl-PL-ZofiaNeural",
      "pl-PL-MarekNeural"
    ],
    "ps": [
      "ps-AF-LatifaNeural",
      "ps-AF-GulNawazNeural"
    ],
    "pt": [
      "pt-BR-FranciscaNeural",
      "pt-BR-AntonioNeural"
    ],
    "pt-br": [
      "pt-BR-FranciscaNeural",
      "pt-BR-AntonioNeural"
    ],
    "pt-pt": [
      "pt-PT-RaquelNeural",
      "pt-PT-DuarteNeural"
    ],
    "ro": [
      "ro-RO-AlinaNeural",
      "ro-RO-EmilNeural"
    ],
    "ro-ro": [
      "ro-RO-AlinaNeural",
      "ro-RO-EmilNeural"
    ],
    "ru": [
      "ru-RU-SvetlanaNeural",
      "ru-RU-DmitryNeural"
    ],
    "ru-ru": [
      "ru-RU-SvetlanaNeural",
      "ru-RU-DmitryNeural"
    ],
    "si": [
      "si-LK-ThiliniNeural",
      "si-LK-SameeraNeural"
    ],
    "sk": [
      "sk-SK-ViktoriaNeural",
      "sk-SK-LukasNeural"
    ],
    "sk-sk": [
      "sk-SK-ViktoriaNeural",
      "sk-SK-LukasNeural"
    ],
    "sl": [
      "sl-SI-PetraNeural",
      "sl-SI-RokNeural"
    ],
    "so": [
      "so-SO-UbaxNeural",
      "so-SO-MuuseNeural"
    ],
    "sq": [
      "sq-AL-AnilaNeural",
      "sq-AL-IlirNeural"
    ],
    "sr": [
      "sr-RS-SophieNeural",
      "sr-RS-NicholasNeural"
    ],
    "su": [
      "su-ID-TutiNeural",
      "su-ID-JajangNeural"
    ],
    "sv": [
      "sv-SE-SofieNeural",
      "sv-SE-MattiasNeural"
    ],
    "sv-se": [
      "sv-SE-SofieNeural",
      "sv-SE-MattiasNeural"
    ],
    "sw": [
      "sw-KE-ZuriNeural",
      "sw-KE-RafikiNeural"
    ],
    "sw-ke": [
      "sw-KE-ZuriNeural",
      "sw-KE-RafikiNeural"
    ],
    "sw-tz": [
      "sw-TZ-RehemaNeural",
      "sw-TZ-DaudiNeural"
    ],
    "ta": [
      "ta-IN-PallaviNeural",
      "ta-IN-ValluvarNeural"
    ],
    "ta-in": [
      "ta-IN-PallaviNeural",
      "ta-IN-ValluvarNeural"
    ],
    "te": [
      "te-IN-ShrutiNeural",
      "te-IN-MohanNeural"
    ],
    "te-in": [
      "te-IN-ShrutiNeural",
      "te-IN-MohanNeural"
    ],
    "th": [
      "th-TH-PremwadeeNeural",
      "th-TH-NiwatNeural"
    ],
    "th-th": [
      "th-TH-PremwadeeNeural",
      "th-TH-NiwatNeural"
    ],
    "tl": [
      "fil-PH-BlessicaNeural",
      "fil-PH-AngeloNeural"
    ],
    "tr": [
      "tr-TR-EmelNeural",
      "tr-TR-AhmetNeural"
    ],
    "tr-tr": [
      "tr-TR-EmelNeural",
      "tr-TR-AhmetNeural"
    ],
    "uk": [
      "uk-UA-PolinaNeural",
      "uk-UA-OstapNeural"
    ],
    "uk-ua": [
      "uk-UA-PolinaNeural",
      "uk-UA-OstapNeural"
    ],
    "ur": [
      "ur-PK-UzmaNeural",
      "ur-PK-AsadNeural"
    ],
    "ur-in": [
      "ur-IN-GulNeural",
      "ur-IN-SalmanNeural"
    ],
    "ur-pk": [
      "ur-PK-UzmaNeural",
      "ur-PK-AsadNeural"
    ],
    "uz": [
      "uz-UZ-MadinaNeural",
      "uz-UZ-SardorNeural"
    ],
    "vi": [
      "vi-VN-HoaiMyNeural",
      "vi-VN-NamMinhNeural"
    ],
    "vi-vn": [
      "vi-VN-HoaiMyNeural",
      "vi-VN-NamMinhNeural"
    ],
    "yue": [
      "zh-HK-HiuGaaiNeural",
      "zh-HK-WanLungNeural"
    ],
    "zh": [
      "zh-CN-XiaoxiaoNeural",
      "zh-CN-YunxiNeural"
    ],
    "zh-cn": [
      "zh-CN-XiaoxiaoNeural",
      "zh-CN-YunjianNeural"
    ],
    "zh-hk": [
      "zh-HK-HiuGaaiNeural",
      "zh-HK-WanLungNeural"
    ],
    "zh-tw": [
      "zh-TW-HsiaoChenNeural",
      "zh-TW-YunJheNeural"
    ],
    "zu": [
      "zu-ZA-ThandoNeural",
      "zu-ZA-ThembaNeural"
    ]
  },
  "elevenlabs": {},
  "f5_tts": {
    "cmn": [
      "default",
      "clone_from_reference"
    ],
    "en": [
      "default",
      "clone_from_reference"
    ],
    "en-gb": [
      "default",
      "clone_from_reference"
    ],
    "en-us": [
      "default",
      "clone_from_reference"
    ],
    "zh": [
      "default",
      "clone_from_reference"
    ],
    "zh-cn": [
      "default",
      "clone_from_reference"
    ],
    "zh-tw": [
      "default",
      "clone_from_reference"
    ]
  },
  "google": {},
  "kokoro": {
    "cmn": [
      "zf_xiaobei",
      "zf_xiaoni",
      "zf_xiaoxiao",
      "zf_xiaoyi",
      "zm_yunjian",
      "zm_yunxi",
      "zm_yunxia",
      "zm_yunyang"
    ],
    "en": [
      "af_alloy",
      "af_aoede",
      "af_bella",
      "af_heart",
      "af_jessica",
      "af_kore",
      "af_nicole",
      "af_nova",
      "af_river",
      "af_sarah",
      "af_sky",
      "am_adam",
      "am_echo",
      "am_eric",
      "am_fenrir",
      "am_liam",
      "am_michael",
      "am_onyx",
      "am_puck",
      "am_santa"
    ],
    "en-gb": [
      "bf_alice",
      "bf_emma",
      "bf_isabella",
      "bf_lily",
      "bm_daniel",
      "bm_fable",
      "bm_george",
      "bm_lewis"
    ],
    "en-us": [
      "af_alloy",
      "af_aoede",
      "af_bella",
      "af_heart",
      "af_jessica",
      "af_kore",
      "af_nicole",
      "af_nova",
      "af_river",
      "af_sarah",
      "af_sky",
      "am_adam",
      "am_echo",
      "am_eric",
      "am_fenrir",
      "am_liam",
      "am_michael",
      "am_onyx",
      "am_puck",
      "am_santa"
    ],
    "es": [
      "ef_dora",
      "em_alex",
      "em_santa"
    ],
    "fr": [
      "ff_siwis"
    ],
    "hi": [
      "hf_alpha",
      "hf_beta",
      "hm_omega",
      "hm_psi"
    ],
    "it": [
      "if_sara",
      "im_nicola"
    ],
    "ja": [
      "jf_alpha",
      "jf_gongitsune",
      "jf_nezumi",
      "jf_tebukuro",
      "jm_kumo"
    ],
    "pt": [
      "pf_dora",
      "pm_alex",
      "pm_santa"
    ],
    "pt-br": [
      "pf_dora",
      "pm_alex",
      "pm_santa"
    ],
    "zh": [
      "zf_xiaobei",
      "zf_xiaoni",
      "zf_xiaoxiao",
      "zf_xiaoyi",
      "zm_yunjian",
      "zm_yunxi",
      "zm_yunxia",
      "zm_yunyang"
    ]
  },
  "minimax": {
    "ar": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "de": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "en": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "en-gb": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "en-us": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "es": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "fr": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "hi": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "it": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "ja": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "ko": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "pt": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "pt-br": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "ru": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ],
    "zh": [
      "Wise_Woman",
      "Friendly_Person",
      "Inspirational_girl",
      "Deep_Voice_Man",
      "Calm_Woman",
      "Energetic_Girl",
      "Patient_Man",
      "Gentle_Woman",
      "Warm_Man",
      "Sweet_Girl_2"
    ]
  },
  "pyttsx3": {}
};

export const TTS_LANGUAGE_SUPPORT: Record<string, string[] | string> = {
  "chatterbox": [
    "en",
    "en-us",
    "en-gb",
    "zh",
    "ja",
    "ko",
    "fr",
    "de",
    "es",
    "pt",
    "pt-br",
    "it",
    "ru",
    "ar",
    "hi",
    "nl",
    "pl",
    "tr",
    "vi",
    "th",
    "id",
    "cs",
    "sv"
  ],
  "chatterbox_turbo": [
    "en",
    "en-us",
    "en-gb",
    "zh",
    "ja",
    "ko",
    "fr",
    "de",
    "es",
    "pt",
    "pt-br",
    "it",
    "ru",
    "ar",
    "hi",
    "nl",
    "pl",
    "tr",
    "vi",
    "th",
    "id",
    "cs",
    "sv"
  ],
  "edge_tts": [
    "en",
    "en-us",
    "en-gb",
    "en-au",
    "en-in",
    "pt",
    "pt-br",
    "pt-pt",
    "es",
    "es-es",
    "es-mx",
    "es-ar",
    "fr",
    "fr-fr",
    "fr-ca",
    "de",
    "de-de",
    "de-at",
    "it",
    "it-it",
    "ja",
    "ja-jp",
    "ko",
    "ko-kr",
    "zh",
    "zh-cn",
    "zh-tw",
    "ru",
    "ru-ru",
    "ar",
    "ar-sa",
    "hi",
    "hi-in",
    "nl",
    "nl-nl",
    "pl",
    "pl-pl",
    "tr",
    "tr-tr",
    "vi",
    "vi-vn",
    "th",
    "th-th",
    "id",
    "id-id",
    "ms",
    "ms-my",
    "tl",
    "fil",
    "fil-ph",
    "cs",
    "cs-cz",
    "sv",
    "sv-se",
    "da",
    "da-dk",
    "no",
    "nb",
    "nb-no",
    "fi",
    "fi-fi",
    "el",
    "el-gr",
    "he",
    "he-il",
    "ro",
    "ro-ro",
    "hu",
    "hu-hu",
    "sk",
    "sk-sk",
    "uk",
    "uk-ua",
    "bn",
    "bn-in",
    "ta",
    "ta-in",
    "te",
    "te-in",
    "mr",
    "mr-in",
    "gu",
    "gu-in",
    "kn",
    "kn-in",
    "ml",
    "ml-in",
    "fa",
    "fa-ir",
    "af",
    "am",
    "az",
    "bg",
    "bs",
    "ca",
    "cy",
    "et",
    "ga",
    "gl",
    "hr",
    "is",
    "jv",
    "ka",
    "kk",
    "km",
    "lo",
    "lt",
    "lv",
    "mk",
    "mn",
    "mt",
    "my",
    "ne",
    "ps",
    "si",
    "sl",
    "so",
    "sq",
    "sr",
    "su",
    "sw",
    "sw-ke",
    "sw-tz",
    "ur",
    "ur-pk",
    "ur-in",
    "uz",
    "zu",
    "yue",
    "zh-hk"
  ],
  "elevenlabs": [
    "en",
    "zh",
    "es",
    "hi",
    "pt",
    "fr",
    "de",
    "ja",
    "ar",
    "ru",
    "ko",
    "id",
    "it",
    "nl",
    "tr",
    "pl",
    "sv",
    "fil",
    "ms",
    "ro",
    "uk",
    "el",
    "cs",
    "da",
    "fi",
    "bg",
    "hr",
    "sk",
    "ta"
  ],
  "f5_tts": [
    "en",
    "en-us",
    "en-gb",
    "zh",
    "zh-cn",
    "zh-tw",
    "cmn"
  ],
  "google": [
    "af",
    "am",
    "ar",
    "bg",
    "bn",
    "bs",
    "ca",
    "cs",
    "cy",
    "da",
    "de",
    "el",
    "en",
    "es",
    "et",
    "eu",
    "fi",
    "fr",
    "fr-CA",
    "gl",
    "gu",
    "ha",
    "hi",
    "hr",
    "hu",
    "id",
    "is",
    "it",
    "iw",
    "ja",
    "jw",
    "km",
    "kn",
    "ko",
    "la",
    "lt",
    "lv",
    "ml",
    "mr",
    "ms",
    "my",
    "ne",
    "nl",
    "no",
    "pa",
    "pl",
    "pt",
    "pt-PT",
    "ro",
    "ru",
    "si",
    "sk",
    "sq",
    "sr",
    "su",
    "sv",
    "sw",
    "ta",
    "te",
    "th",
    "tl",
    "tr",
    "uk",
    "ur",
    "vi",
    "yue",
    "zh",
    "zh-CN",
    "zh-TW",
    "pt-br",
    "en-us",
    "en-gb",
    "en-029",
    "en-gb-scotland",
    "en-gb-x-gbclan",
    "en-gb-x-gbcwmd",
    "en-gb-x-rp",
    "cmn",
    "es-419",
    "fr-be",
    "fr-ch",
    "ru-lv",
    "vi-vn-x-central",
    "vi-vn-x-south",
    "nb"
  ],
  "kokoro": [
    "pt-br",
    "pt",
    "en",
    "en-us",
    "en-gb",
    "es",
    "fr",
    "de",
    "it",
    "ja",
    "ko",
    "zh",
    "cmn",
    "zh-cn",
    "zh-tw",
    "hi"
  ],
  "minimax": [
    "en",
    "en-us",
    "en-gb",
    "zh",
    "ja",
    "ko",
    "fr",
    "de",
    "es",
    "pt",
    "pt-br",
    "it",
    "ru",
    "ar",
    "hi"
  ],
  "pyttsx3": "auto"
};

// ============================================
// BACKEND CONSTANTS (from constants module)
// ============================================

export const DEFAULT_PROVIDER = "openrouter";

// TTS Provider choices - derived from TTS_PROVIDERS
export const TTS_PROVIDERS_CHOICES = TTS_PROVIDERS;

// TTS Language Provider Map - derived from TTS_LANGUAGE_SUPPORT
export const TTS_LANGUAGE_PROVIDER_MAP = TTS_LANGUAGE_SUPPORT;

// ============================================
// GENERATED TTS VOICES WITH FULL METADATA
// ============================================

export const TTS_VOICES: Record<Language, Record<TTSProvider, VoiceOption[]>> = {
  "cmn": {
    "kokoro": [
      {
        "id": "zf_xiaobei",
        "name": "Xiaobei",
        "gender": "female",
        "language": "cmn",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zf_xiaoni",
        "name": "Xiaoni",
        "gender": "female",
        "language": "cmn",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zf_xiaoxiao",
        "name": "Xiaoxiao",
        "gender": "female",
        "language": "cmn",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zf_xiaoyi",
        "name": "Xiaoyi",
        "gender": "female",
        "language": "cmn",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zm_yunjian",
        "name": "Yunjian",
        "gender": "male",
        "language": "cmn",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zm_yunxi",
        "name": "Yunxi",
        "gender": "male",
        "language": "cmn",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zm_yunxia",
        "name": "Yunxia",
        "gender": "male",
        "language": "cmn",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zm_yunyang",
        "name": "Yunyang",
        "gender": "male",
        "language": "cmn",
        "provider": "kokoro",
        "grade": "D"
      }
    ],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "cmn",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [
      {
        "id": "default",
        "name": "Default Voice",
        "gender": "neutral",
        "language": "cmn",
        "provider": "f5_tts"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "cmn",
        "provider": "f5_tts"
      }
    ],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "es": {
    "kokoro": [
      {
        "id": "ef_dora",
        "name": "Dora",
        "gender": "female",
        "language": "es",
        "provider": "kokoro"
      },
      {
        "id": "em_alex",
        "name": "Alex",
        "gender": "male",
        "language": "es",
        "provider": "kokoro"
      },
      {
        "id": "em_santa",
        "name": "Santa",
        "gender": "male",
        "language": "es",
        "provider": "kokoro"
      }
    ],
    "edge_tts": [
      {
        "id": "es-ES-ElviraNeural",
        "name": "Elvira (ES)",
        "gender": "female",
        "language": "es",
        "provider": "edge_tts"
      },
      {
        "id": "es-ES-AlvaroNeural",
        "name": "Alvaro (ES)",
        "gender": "male",
        "language": "es",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "es-ES-Standard-A",
        "name": "Google ES",
        "gender": "female",
        "language": "es",
        "provider": "google"
      },
      {
        "id": "es-ES-Standard-B",
        "name": "Google ES",
        "gender": "male",
        "language": "es",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "es",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "es",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "es",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "es",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "es",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "es",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "es",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "es",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "es",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "es",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "es",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "es",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "en-us": {
    "kokoro": [
      {
        "id": "af_alloy",
        "name": "Alloy",
        "gender": "female",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "C"
      },
      {
        "id": "af_aoede",
        "name": "Aoede",
        "gender": "female",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "C+"
      },
      {
        "id": "af_bella",
        "name": "Bella",
        "gender": "female",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "A-",
        "emoticon": "🔥"
      },
      {
        "id": "af_heart",
        "name": "Heart",
        "gender": "female",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "A",
        "emoticon": "❤️"
      },
      {
        "id": "af_jessica",
        "name": "Jessica",
        "gender": "female",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "af_kore",
        "name": "Kore",
        "gender": "female",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "C+"
      },
      {
        "id": "af_nicole",
        "name": "Nicole",
        "gender": "female",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "B-",
        "emoticon": "🎧"
      },
      {
        "id": "af_nova",
        "name": "Nova",
        "gender": "female",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "C"
      },
      {
        "id": "af_river",
        "name": "River",
        "gender": "female",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "af_sarah",
        "name": "Sarah",
        "gender": "female",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "C+"
      },
      {
        "id": "af_sky",
        "name": "Sky",
        "gender": "female",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "C-"
      },
      {
        "id": "am_adam",
        "name": "Adam",
        "gender": "male",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "F+"
      },
      {
        "id": "am_echo",
        "name": "Echo",
        "gender": "male",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "am_eric",
        "name": "Eric",
        "gender": "male",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "am_fenrir",
        "name": "Fenrir",
        "gender": "male",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "C+"
      },
      {
        "id": "am_liam",
        "name": "Liam",
        "gender": "male",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "am_michael",
        "name": "Michael",
        "gender": "male",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "C+"
      },
      {
        "id": "am_onyx",
        "name": "Onyx",
        "gender": "male",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "am_puck",
        "name": "Puck",
        "gender": "male",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "C+"
      },
      {
        "id": "am_santa",
        "name": "Santa",
        "gender": "male",
        "language": "en-us",
        "provider": "kokoro",
        "grade": "D-"
      }
    ],
    "edge_tts": [
      {
        "id": "en-US-AriaNeural",
        "name": "Aria (US)",
        "gender": "female",
        "language": "en-us",
        "provider": "edge_tts"
      },
      {
        "id": "en-US-GuyNeural",
        "name": "Guy (US)",
        "gender": "male",
        "language": "en-us",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "en-US-Standard-A",
        "name": "Google US",
        "gender": "female",
        "language": "en-us",
        "provider": "google"
      },
      {
        "id": "en-US-Standard-B",
        "name": "Google US",
        "gender": "male",
        "language": "en-us",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "en-us",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [
      {
        "id": "default",
        "name": "Default Voice",
        "gender": "neutral",
        "language": "en-us",
        "provider": "f5_tts"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-us",
        "provider": "f5_tts"
      }
    ],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "en-us",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "en-us",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "en-us",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "en-us",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "en-us",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "en-us",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "en-us",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "en-us",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "en-us",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "en-us",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "en-us",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "hi": {
    "kokoro": [
      {
        "id": "hf_alpha",
        "name": "Alpha",
        "gender": "female",
        "language": "hi",
        "provider": "kokoro",
        "grade": "C"
      },
      {
        "id": "hf_beta",
        "name": "Beta",
        "gender": "female",
        "language": "hi",
        "provider": "kokoro",
        "grade": "C"
      },
      {
        "id": "hm_omega",
        "name": "Omega",
        "gender": "male",
        "language": "hi",
        "provider": "kokoro",
        "grade": "C"
      },
      {
        "id": "hm_psi",
        "name": "Psi",
        "gender": "male",
        "language": "hi",
        "provider": "kokoro",
        "grade": "C"
      }
    ],
    "edge_tts": [
      {
        "id": "hi-IN-SwaraNeural",
        "name": "Swara (IN)",
        "gender": "female",
        "language": "hi",
        "provider": "edge_tts"
      },
      {
        "id": "hi-IN-MadhurNeural",
        "name": "Madhur (IN)",
        "gender": "male",
        "language": "hi",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "hi-IN-Standard-A",
        "name": "Google HI",
        "gender": "female",
        "language": "hi",
        "provider": "google"
      },
      {
        "id": "hi-IN-Standard-B",
        "name": "Google HI",
        "gender": "male",
        "language": "hi",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "hi",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "hi",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "hi",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "hi",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "hi",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "hi",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "hi",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "hi",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "hi",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "hi",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "hi",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "hi",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "ar": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ar-SA-ZariyahNeural",
        "name": "Zariyah (SA)",
        "gender": "female",
        "language": "ar",
        "provider": "edge_tts"
      },
      {
        "id": "ar-SA-HamedNeural",
        "name": "Hamed (SA)",
        "gender": "male",
        "language": "ar",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "ar-XA-Standard-A",
        "name": "Google AR",
        "gender": "female",
        "language": "ar",
        "provider": "google"
      },
      {
        "id": "ar-XA-Standard-B",
        "name": "Google AR",
        "gender": "male",
        "language": "ar",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ar",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "ar",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "ar",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "ar",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "ar",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "ar",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "ar",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "ar",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "ar",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "ar",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "ar",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "ar",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "bn": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "bn-IN-TanishaaNeural",
        "name": "Tanishaa (IN)",
        "gender": "female",
        "language": "bn",
        "provider": "edge_tts"
      },
      {
        "id": "bn-IN-BashkarNeural",
        "name": "Bashkar (IN)",
        "gender": "male",
        "language": "bn",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "bn",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "pt-br": {
    "kokoro": [
      {
        "id": "pf_dora",
        "name": "Dora",
        "gender": "female",
        "language": "pt-br",
        "provider": "kokoro"
      },
      {
        "id": "pm_alex",
        "name": "Alex",
        "gender": "male",
        "language": "pt-br",
        "provider": "kokoro"
      },
      {
        "id": "pm_santa",
        "name": "Santa",
        "gender": "male",
        "language": "pt-br",
        "provider": "kokoro"
      }
    ],
    "edge_tts": [
      {
        "id": "pt-BR-FranciscaNeural",
        "name": "Francisca (BR)",
        "gender": "female",
        "language": "pt-br",
        "provider": "edge_tts"
      },
      {
        "id": "pt-BR-AntonioNeural",
        "name": "Antonio (BR)",
        "gender": "male",
        "language": "pt-br",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "pt-BR-Standard-A",
        "name": "Google PT-BR",
        "gender": "female",
        "language": "pt-br",
        "provider": "google"
      },
      {
        "id": "pt-BR-Standard-B",
        "name": "Google PT-BR",
        "gender": "male",
        "language": "pt-br",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "pt-br",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "ru": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ru-RU-SvetlanaNeural",
        "name": "Svetlana (RU)",
        "gender": "female",
        "language": "ru",
        "provider": "edge_tts"
      },
      {
        "id": "ru-RU-DmitryNeural",
        "name": "Dmitry (RU)",
        "gender": "male",
        "language": "ru",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "ru-RU-Standard-A",
        "name": "Google RU",
        "gender": "female",
        "language": "ru",
        "provider": "google"
      },
      {
        "id": "ru-RU-Standard-B",
        "name": "Google RU",
        "gender": "male",
        "language": "ru",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ru",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "ru",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "ru",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "ru",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "ru",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "ru",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "ru",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "ru",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "ru",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "ru",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "ru",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "ru",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "ja": {
    "kokoro": [
      {
        "id": "jf_alpha",
        "name": "Alpha",
        "gender": "female",
        "language": "ja",
        "provider": "kokoro",
        "grade": "C+"
      },
      {
        "id": "jf_gongitsune",
        "name": "Gongitsune",
        "gender": "female",
        "language": "ja",
        "provider": "kokoro",
        "grade": "C"
      },
      {
        "id": "jf_nezumi",
        "name": "Nezumi",
        "gender": "female",
        "language": "ja",
        "provider": "kokoro",
        "grade": "C-"
      },
      {
        "id": "jf_tebukuro",
        "name": "Tebukuro",
        "gender": "female",
        "language": "ja",
        "provider": "kokoro",
        "grade": "C"
      },
      {
        "id": "jm_kumo",
        "name": "Kumo",
        "gender": "male",
        "language": "ja",
        "provider": "kokoro",
        "grade": "C-"
      }
    ],
    "edge_tts": [
      {
        "id": "ja-JP-NanamiNeural",
        "name": "Nanami (JP)",
        "gender": "female",
        "language": "ja",
        "provider": "edge_tts"
      },
      {
        "id": "ja-JP-KeitaNeural",
        "name": "Keita (JP)",
        "gender": "male",
        "language": "ja",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "ja-JP-Standard-A",
        "name": "Google JA",
        "gender": "female",
        "language": "ja",
        "provider": "google"
      },
      {
        "id": "ja-JP-Standard-B",
        "name": "Google JA",
        "gender": "male",
        "language": "ja",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ja",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "ja",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "ja",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "ja",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "ja",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "ja",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "ja",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "ja",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "ja",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "ja",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "ja",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "ja",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "pa": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "pa",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "de": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "de-DE-KatjaNeural",
        "name": "Katja (DE)",
        "gender": "female",
        "language": "de",
        "provider": "edge_tts"
      },
      {
        "id": "de-DE-ConradNeural",
        "name": "Conrad (DE)",
        "gender": "male",
        "language": "de",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "de-DE-Standard-A",
        "name": "Google DE",
        "gender": "female",
        "language": "de",
        "provider": "google"
      },
      {
        "id": "de-DE-Standard-B",
        "name": "Google DE",
        "gender": "male",
        "language": "de",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "de",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "de",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "de",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "de",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "de",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "de",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "de",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "de",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "de",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "de",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "de",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "de",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "id": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "id-ID-GadisNeural",
        "name": "Gadis (ID)",
        "gender": "female",
        "language": "id",
        "provider": "edge_tts"
      },
      {
        "id": "id-ID-ArdiNeural",
        "name": "Ardi (ID)",
        "gender": "male",
        "language": "id",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "id",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox"
      }
    ],
    "minimax": [],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "id",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "fr": {
    "kokoro": [
      {
        "id": "ff_siwis",
        "name": "Siwis",
        "gender": "female",
        "language": "fr",
        "provider": "kokoro",
        "grade": "B-"
      }
    ],
    "edge_tts": [
      {
        "id": "fr-FR-DeniseNeural",
        "name": "Denise (FR)",
        "gender": "female",
        "language": "fr",
        "provider": "edge_tts"
      },
      {
        "id": "fr-FR-HenriNeural",
        "name": "Henri (FR)",
        "gender": "male",
        "language": "fr",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "fr-FR-Standard-A",
        "name": "Google FR",
        "gender": "female",
        "language": "fr",
        "provider": "google"
      },
      {
        "id": "fr-FR-Standard-B",
        "name": "Google FR",
        "gender": "male",
        "language": "fr",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "fr",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "fr",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "fr",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "fr",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "fr",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "fr",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "fr",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "fr",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "fr",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "fr",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "fr",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "fr",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "tr": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "tr-TR-EmelNeural",
        "name": "Emel (TR)",
        "gender": "female",
        "language": "tr",
        "provider": "edge_tts"
      },
      {
        "id": "tr-TR-AhmetNeural",
        "name": "Ahmet (TR)",
        "gender": "male",
        "language": "tr",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "tr",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox"
      }
    ],
    "minimax": [],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "tr",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "ko": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ko-KR-SunHiNeural",
        "name": "SunHi (KR)",
        "gender": "female",
        "language": "ko",
        "provider": "edge_tts"
      },
      {
        "id": "ko-KR-InJoonNeural",
        "name": "InJoon (KR)",
        "gender": "male",
        "language": "ko",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "ko-KR-Standard-A",
        "name": "Google KO",
        "gender": "female",
        "language": "ko",
        "provider": "google"
      },
      {
        "id": "ko-KR-Standard-B",
        "name": "Google KO",
        "gender": "male",
        "language": "ko",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ko",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "ko",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "ko",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "ko",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "ko",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "ko",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "ko",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "ko",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "ko",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "ko",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "ko",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "ko",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "te": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "te-IN-ShrutiNeural",
        "name": "Shruti (IN)",
        "gender": "female",
        "language": "te",
        "provider": "edge_tts"
      },
      {
        "id": "te-IN-MohanNeural",
        "name": "Mohan (IN)",
        "gender": "male",
        "language": "te",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "te",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "vi": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "vi-VN-HoaiMyNeural",
        "name": "HoaiMy (VN)",
        "gender": "female",
        "language": "vi",
        "provider": "edge_tts"
      },
      {
        "id": "vi-VN-NamMinhNeural",
        "name": "NamMinh (VN)",
        "gender": "male",
        "language": "vi",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "vi",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox"
      }
    ],
    "minimax": [],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "vi",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "ta": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ta-IN-PallaviNeural",
        "name": "Pallavi (IN)",
        "gender": "female",
        "language": "ta",
        "provider": "edge_tts"
      },
      {
        "id": "ta-IN-ValluvarNeural",
        "name": "Valluvar (IN)",
        "gender": "male",
        "language": "ta",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ta",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "it": {
    "kokoro": [
      {
        "id": "if_sara",
        "name": "Sara",
        "gender": "female",
        "language": "it",
        "provider": "kokoro",
        "grade": "C"
      },
      {
        "id": "im_nicola",
        "name": "Nicola",
        "gender": "male",
        "language": "it",
        "provider": "kokoro",
        "grade": "C"
      }
    ],
    "edge_tts": [
      {
        "id": "it-IT-ElsaNeural",
        "name": "Elsa (IT)",
        "gender": "female",
        "language": "it",
        "provider": "edge_tts"
      },
      {
        "id": "it-IT-DiegoNeural",
        "name": "Diego (IT)",
        "gender": "male",
        "language": "it",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "it-IT-Standard-A",
        "name": "Google IT",
        "gender": "female",
        "language": "it",
        "provider": "google"
      },
      {
        "id": "it-IT-Standard-B",
        "name": "Google IT",
        "gender": "male",
        "language": "it",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "it",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "it",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "it",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "it",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "it",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "it",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "it",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "it",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "it",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "it",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "it",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "it",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "ur": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ur-PK-UzmaNeural",
        "name": "Uzma (PK)",
        "gender": "female",
        "language": "ur",
        "provider": "edge_tts"
      },
      {
        "id": "ur-PK-AsadNeural",
        "name": "Asad (PK)",
        "gender": "male",
        "language": "ur",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ur",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "es-419": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "es-419",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ca": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ca-ES-JoanaNeural",
        "name": "Joana (ES)",
        "gender": "female",
        "language": "ca",
        "provider": "edge_tts"
      },
      {
        "id": "ca-ES-EnricNeural",
        "name": "Enric (ES)",
        "gender": "male",
        "language": "ca",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ca",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "fr-be": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "fr-be",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "fr-ch": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "fr-ch",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ro": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ro-RO-AlinaNeural",
        "name": "Alina (RO)",
        "gender": "female",
        "language": "ro",
        "provider": "edge_tts"
      },
      {
        "id": "ro-RO-EmilNeural",
        "name": "Emil (RO)",
        "gender": "male",
        "language": "ro",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ro",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "an": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "an",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ht": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ht",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "pap": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "pap",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "en-gb": {
    "kokoro": [
      {
        "id": "bf_alice",
        "name": "Alice",
        "gender": "female",
        "language": "en-gb",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "bf_emma",
        "name": "Emma",
        "gender": "female",
        "language": "en-gb",
        "provider": "kokoro",
        "grade": "B-"
      },
      {
        "id": "bf_isabella",
        "name": "Isabella",
        "gender": "female",
        "language": "en-gb",
        "provider": "kokoro",
        "grade": "C"
      },
      {
        "id": "bf_lily",
        "name": "Lily",
        "gender": "female",
        "language": "en-gb",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "bm_daniel",
        "name": "Daniel",
        "gender": "male",
        "language": "en-gb",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "bm_fable",
        "name": "Fable",
        "gender": "male",
        "language": "en-gb",
        "provider": "kokoro",
        "grade": "C"
      },
      {
        "id": "bm_george",
        "name": "George",
        "gender": "male",
        "language": "en-gb",
        "provider": "kokoro",
        "grade": "C"
      },
      {
        "id": "bm_lewis",
        "name": "Lewis",
        "gender": "male",
        "language": "en-gb",
        "provider": "kokoro",
        "grade": "D+"
      }
    ],
    "edge_tts": [
      {
        "id": "en-GB-SoniaNeural",
        "name": "Sonia (UK)",
        "gender": "female",
        "language": "en-gb",
        "provider": "edge_tts"
      },
      {
        "id": "en-GB-RyanNeural",
        "name": "Ryan (UK)",
        "gender": "male",
        "language": "en-gb",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "en-GB-Standard-A",
        "name": "Google UK",
        "gender": "female",
        "language": "en-gb",
        "provider": "google"
      },
      {
        "id": "en-GB-Standard-B",
        "name": "Google UK",
        "gender": "male",
        "language": "en-gb",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [
      {
        "id": "default",
        "name": "Default Voice",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "f5_tts"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "f5_tts"
      }
    ],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "en-gb",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "en-029": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "en-US-AriaNeural",
        "name": "Aria (US)",
        "gender": "female",
        "language": "en-029",
        "provider": "edge_tts"
      },
      {
        "id": "en-US-GuyNeural",
        "name": "Guy (US)",
        "gender": "male",
        "language": "en-029",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "en-029",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [
      {
        "id": "default",
        "name": "Default Voice",
        "gender": "neutral",
        "language": "en-029",
        "provider": "f5_tts"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-029",
        "provider": "f5_tts"
      }
    ],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "en-029",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "en-029",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "en-029",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "en-029",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "en-029",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "en-029",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "en-029",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "en-029",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "en-029",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "en-029",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "en-029",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "en-gb-scotland": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "en-US-AriaNeural",
        "name": "Aria (US)",
        "gender": "female",
        "language": "en-gb-scotland",
        "provider": "edge_tts"
      },
      {
        "id": "en-US-GuyNeural",
        "name": "Guy (US)",
        "gender": "male",
        "language": "en-gb-scotland",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [
      {
        "id": "default",
        "name": "Default Voice",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "f5_tts"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "f5_tts"
      }
    ],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "en-gb-scotland",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "en-gb-x-gbclan": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "en-US-AriaNeural",
        "name": "Aria (US)",
        "gender": "female",
        "language": "en-gb-x-gbclan",
        "provider": "edge_tts"
      },
      {
        "id": "en-US-GuyNeural",
        "name": "Guy (US)",
        "gender": "male",
        "language": "en-gb-x-gbclan",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [
      {
        "id": "default",
        "name": "Default Voice",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "f5_tts"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "f5_tts"
      }
    ],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "en-gb-x-gbclan",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "en-gb-x-gbcwmd": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "en-US-AriaNeural",
        "name": "Aria (US)",
        "gender": "female",
        "language": "en-gb-x-gbcwmd",
        "provider": "edge_tts"
      },
      {
        "id": "en-US-GuyNeural",
        "name": "Guy (US)",
        "gender": "male",
        "language": "en-gb-x-gbcwmd",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [
      {
        "id": "default",
        "name": "Default Voice",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "f5_tts"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "f5_tts"
      }
    ],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "en-gb-x-gbcwmd",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "en-gb-x-rp": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "en-US-AriaNeural",
        "name": "Aria (US)",
        "gender": "female",
        "language": "en-gb-x-rp",
        "provider": "edge_tts"
      },
      {
        "id": "en-US-GuyNeural",
        "name": "Guy (US)",
        "gender": "male",
        "language": "en-gb-x-rp",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [
      {
        "id": "default",
        "name": "Default Voice",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "f5_tts"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "f5_tts"
      }
    ],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "en-gb-x-rp",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "nl": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "nl-NL-ColetteNeural",
        "name": "Colette (NL)",
        "gender": "female",
        "language": "nl",
        "provider": "edge_tts"
      },
      {
        "id": "nl-NL-MaartenNeural",
        "name": "Maarten (NL)",
        "gender": "male",
        "language": "nl",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "nl",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox"
      }
    ],
    "minimax": [],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "nl",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "af": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "af-ZA-AdriNeural",
        "name": "Adri (ZA)",
        "gender": "female",
        "language": "af",
        "provider": "edge_tts"
      },
      {
        "id": "af-ZA-WillemNeural",
        "name": "Willem (ZA)",
        "gender": "male",
        "language": "af",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "af",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "da": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "da-DK-ChristelNeural",
        "name": "Christel (DK)",
        "gender": "female",
        "language": "da",
        "provider": "edge_tts"
      },
      {
        "id": "da-DK-JeppeNeural",
        "name": "Jeppe (DK)",
        "gender": "male",
        "language": "da",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "da",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "is": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "is-IS-GudrunNeural",
        "name": "Gudrun (IS)",
        "gender": "female",
        "language": "is",
        "provider": "edge_tts"
      },
      {
        "id": "is-IS-GunnarNeural",
        "name": "Gunnar (IS)",
        "gender": "male",
        "language": "is",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "is",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "nb": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "nb-NO-PernilleNeural",
        "name": "Pernille (NO)",
        "gender": "female",
        "language": "nb",
        "provider": "edge_tts"
      },
      {
        "id": "nb-NO-FinnNeural",
        "name": "Finn (NO)",
        "gender": "male",
        "language": "nb",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "nb",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "sv": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "sv-SE-SofieNeural",
        "name": "Sofie (SE)",
        "gender": "female",
        "language": "sv",
        "provider": "edge_tts"
      },
      {
        "id": "sv-SE-MattiasNeural",
        "name": "Mattias (SE)",
        "gender": "male",
        "language": "sv",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "sv",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox"
      }
    ],
    "minimax": [],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "sv",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "bg": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "bg-BG-KalinaNeural",
        "name": "Kalina (BG)",
        "gender": "female",
        "language": "bg",
        "provider": "edge_tts"
      },
      {
        "id": "bg-BG-BorislavNeural",
        "name": "Borislav (BG)",
        "gender": "male",
        "language": "bg",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "bg",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "bs": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "bs-BA-VesnaNeural",
        "name": "Vesna (BA)",
        "gender": "female",
        "language": "bs",
        "provider": "edge_tts"
      },
      {
        "id": "bs-BA-GoranNeural",
        "name": "Goran (BA)",
        "gender": "male",
        "language": "bs",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "bs",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "cs": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "cs-CZ-VlastaNeural",
        "name": "Vlasta (CZ)",
        "gender": "female",
        "language": "cs",
        "provider": "edge_tts"
      },
      {
        "id": "cs-CZ-AntoninNeural",
        "name": "Antonin (CZ)",
        "gender": "male",
        "language": "cs",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "cs",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox"
      }
    ],
    "minimax": [],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "cs",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "hr": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "hr-HR-GabrijelaNeural",
        "name": "Gabrijela (HR)",
        "gender": "female",
        "language": "hr",
        "provider": "edge_tts"
      },
      {
        "id": "hr-HR-SreckoNeural",
        "name": "Srecko (HR)",
        "gender": "male",
        "language": "hr",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "hr",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "mk": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "mk-MK-MarijaNeural",
        "name": "Marija (MK)",
        "gender": "female",
        "language": "mk",
        "provider": "edge_tts"
      },
      {
        "id": "mk-MK-AleksandarNeural",
        "name": "Aleksandar (MK)",
        "gender": "male",
        "language": "mk",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "mk",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "pl": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "pl-PL-ZofiaNeural",
        "name": "Zofia (PL)",
        "gender": "female",
        "language": "pl",
        "provider": "edge_tts"
      },
      {
        "id": "pl-PL-MarekNeural",
        "name": "Marek (PL)",
        "gender": "male",
        "language": "pl",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "pl",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox"
      }
    ],
    "minimax": [],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "pl",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "ru-lv": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ru-lv",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "sk": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "sk-SK-ViktoriaNeural",
        "name": "Viktoria (SK)",
        "gender": "female",
        "language": "sk",
        "provider": "edge_tts"
      },
      {
        "id": "sk-SK-LukasNeural",
        "name": "Lukas (SK)",
        "gender": "male",
        "language": "sk",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "sk",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "sl": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "sl-SI-PetraNeural",
        "name": "Petra (SI)",
        "gender": "female",
        "language": "sl",
        "provider": "edge_tts"
      },
      {
        "id": "sl-SI-RokNeural",
        "name": "Rok (SI)",
        "gender": "male",
        "language": "sl",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "sl",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "sr": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "sr-RS-SophieNeural",
        "name": "Sophie (RS)",
        "gender": "female",
        "language": "sr",
        "provider": "edge_tts"
      },
      {
        "id": "sr-RS-NicholasNeural",
        "name": "Nicholas (RS)",
        "gender": "male",
        "language": "sr",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "sr",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "yue": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "zh-HK-HiuGaaiNeural",
        "name": "HiuGaai (HK)",
        "gender": "female",
        "language": "yue",
        "provider": "edge_tts"
      },
      {
        "id": "zh-HK-WanLungNeural",
        "name": "WanLung (HK)",
        "gender": "male",
        "language": "yue",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "yue",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "hak": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "hak",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "vi-vn-x-central": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "vi-vn-x-central",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "vi-vn-x-south": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "vi-vn-x-south",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "shn": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "shn",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "my": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "my-MM-NilarNeural",
        "name": "Nilar (MM)",
        "gender": "female",
        "language": "my",
        "provider": "edge_tts"
      },
      {
        "id": "my-MM-ThihaNeural",
        "name": "Thiha (MM)",
        "gender": "male",
        "language": "my",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "my",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ms": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ms-MY-YasminNeural",
        "name": "Yasmin (MY)",
        "gender": "female",
        "language": "ms",
        "provider": "edge_tts"
      },
      {
        "id": "ms-MY-OsmanNeural",
        "name": "Osman (MY)",
        "gender": "male",
        "language": "ms",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ms",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "as": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "as",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "bpy": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "bpy",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "gu": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "gu-IN-DhwaniNeural",
        "name": "Dhwani (IN)",
        "gender": "female",
        "language": "gu",
        "provider": "edge_tts"
      },
      {
        "id": "gu-IN-NiranjanNeural",
        "name": "Niranjan (IN)",
        "gender": "male",
        "language": "gu",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "gu",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "kok": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "kok",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "mr": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "mr-IN-AarohiNeural",
        "name": "Aarohi (IN)",
        "gender": "female",
        "language": "mr",
        "provider": "edge_tts"
      },
      {
        "id": "mr-IN-ManoharNeural",
        "name": "Manohar (IN)",
        "gender": "male",
        "language": "mr",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "mr",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ne": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ne-NP-HemkalaNeural",
        "name": "Hemkala (NP)",
        "gender": "female",
        "language": "ne",
        "provider": "edge_tts"
      },
      {
        "id": "ne-NP-SagarNeural",
        "name": "Sagar (NP)",
        "gender": "male",
        "language": "ne",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ne",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "or": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "or",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "sd": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "sd",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "si": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "si-LK-ThiliniNeural",
        "name": "Thilini (LK)",
        "gender": "female",
        "language": "si",
        "provider": "edge_tts"
      },
      {
        "id": "si-LK-SameeraNeural",
        "name": "Sameera (LK)",
        "gender": "male",
        "language": "si",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "si",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "kn": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "kn-IN-SapnaNeural",
        "name": "Sapna (IN)",
        "gender": "female",
        "language": "kn",
        "provider": "edge_tts"
      },
      {
        "id": "kn-IN-GaganNeural",
        "name": "Gagan (IN)",
        "gender": "male",
        "language": "kn",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "kn",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ml": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ml-IN-SobhanaNeural",
        "name": "Sobhana (IN)",
        "gender": "female",
        "language": "ml",
        "provider": "edge_tts"
      },
      {
        "id": "ml-IN-MidhunNeural",
        "name": "Midhun (IN)",
        "gender": "male",
        "language": "ml",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ml",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "am": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "am-ET-MekdesNeural",
        "name": "Mekdes (ET)",
        "gender": "female",
        "language": "am",
        "provider": "edge_tts"
      },
      {
        "id": "am-ET-AmehaNeural",
        "name": "Ameha (ET)",
        "gender": "male",
        "language": "am",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "am",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "mt": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "mt-MT-GraceNeural",
        "name": "Grace (MT)",
        "gender": "female",
        "language": "mt",
        "provider": "edge_tts"
      },
      {
        "id": "mt-MT-JosephNeural",
        "name": "Joseph (MT)",
        "gender": "male",
        "language": "mt",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "mt",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "az": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "az-AZ-BanuNeural",
        "name": "Banu (AZ)",
        "gender": "female",
        "language": "az",
        "provider": "edge_tts"
      },
      {
        "id": "az-AZ-BabekNeural",
        "name": "Babek (AZ)",
        "gender": "male",
        "language": "az",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "az",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ba": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ba",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "kk": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "kk-KZ-AigulNeural",
        "name": "Aigul (KZ)",
        "gender": "female",
        "language": "kk",
        "provider": "edge_tts"
      },
      {
        "id": "kk-KZ-DauletNeural",
        "name": "Daulet (KZ)",
        "gender": "male",
        "language": "kk",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "kk",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ky": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ky",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "tt": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "tt",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "uz": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "uz-UZ-MadinaNeural",
        "name": "Madina (UZ)",
        "gender": "female",
        "language": "uz",
        "provider": "edge_tts"
      },
      {
        "id": "uz-UZ-SardorNeural",
        "name": "Sardor (UZ)",
        "gender": "male",
        "language": "uz",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "uz",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "fa": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "fa-IR-DilaraNeural",
        "name": "Dilara (IR)",
        "gender": "female",
        "language": "fa",
        "provider": "edge_tts"
      },
      {
        "id": "fa-IR-FaridNeural",
        "name": "Farid (IR)",
        "gender": "male",
        "language": "fa",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "fa",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "fa-latn": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "fa-latn",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ku": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ku",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "cy": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "cy-GB-NiaNeural",
        "name": "Nia (UK)",
        "gender": "female",
        "language": "cy",
        "provider": "edge_tts"
      },
      {
        "id": "cy-GB-AledNeural",
        "name": "Aled (UK)",
        "gender": "male",
        "language": "cy",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "cy",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ga": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ga-IE-OrlaNeural",
        "name": "Orla (IE)",
        "gender": "female",
        "language": "ga",
        "provider": "edge_tts"
      },
      {
        "id": "ga-IE-ColmNeural",
        "name": "Colm (IE)",
        "gender": "male",
        "language": "ga",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ga",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "gd": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "gd",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "lt": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "lt-LT-OnaNeural",
        "name": "Ona (LT)",
        "gender": "female",
        "language": "lt",
        "provider": "edge_tts"
      },
      {
        "id": "lt-LT-LeonasNeural",
        "name": "Leonas (LT)",
        "gender": "male",
        "language": "lt",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "lt",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "lv": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "lv-LV-EveritaNeural",
        "name": "Everita (LV)",
        "gender": "female",
        "language": "lv",
        "provider": "edge_tts"
      },
      {
        "id": "lv-LV-NilsNeural",
        "name": "Nils (LV)",
        "gender": "male",
        "language": "lv",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "lv",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "et": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "et-EE-AnuNeural",
        "name": "Anu (EE)",
        "gender": "female",
        "language": "et",
        "provider": "edge_tts"
      },
      {
        "id": "et-EE-KertNeural",
        "name": "Kert (EE)",
        "gender": "male",
        "language": "et",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "et",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "fi": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "fi-FI-NooraNeural",
        "name": "Noora (FI)",
        "gender": "female",
        "language": "fi",
        "provider": "edge_tts"
      },
      {
        "id": "fi-FI-HarriNeural",
        "name": "Harri (FI)",
        "gender": "male",
        "language": "fi",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "fi",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "hu": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "hu-HU-NoemiNeural",
        "name": "Noemi (HU)",
        "gender": "female",
        "language": "hu",
        "provider": "edge_tts"
      },
      {
        "id": "hu-HU-TamasNeural",
        "name": "Tamas (HU)",
        "gender": "male",
        "language": "hu",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "hu",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "kl": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "kl",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "quc": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "quc",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "gn": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "gn",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "tpw": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "tpw",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "el": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "el-GR-AthinaNeural",
        "name": "Athina (GR)",
        "gender": "female",
        "language": "el",
        "provider": "edge_tts"
      },
      {
        "id": "el-GR-NestorasNeural",
        "name": "Nestoras (GR)",
        "gender": "male",
        "language": "el",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "el",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "grc": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "grc",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "sq": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "sq-AL-AnilaNeural",
        "name": "Anila (AL)",
        "gender": "female",
        "language": "sq",
        "provider": "edge_tts"
      },
      {
        "id": "sq-AL-IlirNeural",
        "name": "Ilir (AL)",
        "gender": "male",
        "language": "sq",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "sq",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "hy": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "hy",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "hyw": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "hyw",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "la": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "la",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ka": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ka-GE-EkaNeural",
        "name": "Eka (GE)",
        "gender": "female",
        "language": "ka",
        "provider": "edge_tts"
      },
      {
        "id": "ka-GE-GiorgiNeural",
        "name": "Giorgi (GE)",
        "gender": "male",
        "language": "ka",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ka",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "sw": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "sw-KE-ZuriNeural",
        "name": "Zuri (KE)",
        "gender": "female",
        "language": "sw",
        "provider": "edge_tts"
      },
      {
        "id": "sw-KE-RafikiNeural",
        "name": "Rafiki (KE)",
        "gender": "male",
        "language": "sw",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "sw",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "tn": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "tn",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "om": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "om",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "mi": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "mi",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "nci": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "nci",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "lfn": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "lfn",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "eo": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "eo",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ia": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ia",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "jbo": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "jbo",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "zh": {
    "kokoro": [
      {
        "id": "zf_xiaobei",
        "name": "Xiaobei",
        "gender": "female",
        "language": "zh",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zf_xiaoni",
        "name": "Xiaoni",
        "gender": "female",
        "language": "zh",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zf_xiaoxiao",
        "name": "Xiaoxiao",
        "gender": "female",
        "language": "zh",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zf_xiaoyi",
        "name": "Xiaoyi",
        "gender": "female",
        "language": "zh",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zm_yunjian",
        "name": "Yunjian",
        "gender": "male",
        "language": "zh",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zm_yunxi",
        "name": "Yunxi",
        "gender": "male",
        "language": "zh",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zm_yunxia",
        "name": "Yunxia",
        "gender": "male",
        "language": "zh",
        "provider": "kokoro",
        "grade": "D"
      },
      {
        "id": "zm_yunyang",
        "name": "Yunyang",
        "gender": "male",
        "language": "zh",
        "provider": "kokoro",
        "grade": "D"
      }
    ],
    "edge_tts": [
      {
        "id": "zh-CN-XiaoxiaoNeural",
        "name": "Xiaoxiao (CN)",
        "gender": "female",
        "language": "zh",
        "provider": "edge_tts"
      },
      {
        "id": "zh-CN-YunxiNeural",
        "name": "Yunxi (CN)",
        "gender": "male",
        "language": "zh",
        "provider": "edge_tts"
      }
    ],
    "google": [
      {
        "id": "zh-CN-Standard-A",
        "name": "Google ZH",
        "gender": "female",
        "language": "zh",
        "provider": "google"
      },
      {
        "id": "zh-CN-Standard-B",
        "name": "Google ZH",
        "gender": "male",
        "language": "zh",
        "provider": "google"
      }
    ],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "zh",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [
      {
        "id": "default",
        "name": "Default Voice",
        "gender": "neutral",
        "language": "zh",
        "provider": "f5_tts"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "zh",
        "provider": "f5_tts"
      }
    ],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox"
      }
    ],
    "minimax": [
      {
        "id": "Wise_Woman",
        "name": "Wise_Woman",
        "gender": "neutral",
        "language": "zh",
        "provider": "minimax"
      },
      {
        "id": "Friendly_Person",
        "name": "Friendly_Person",
        "gender": "neutral",
        "language": "zh",
        "provider": "minimax"
      },
      {
        "id": "Inspirational_girl",
        "name": "Inspirational_girl",
        "gender": "neutral",
        "language": "zh",
        "provider": "minimax"
      },
      {
        "id": "Deep_Voice_Man",
        "name": "Deep_Voice_Man",
        "gender": "neutral",
        "language": "zh",
        "provider": "minimax"
      },
      {
        "id": "Calm_Woman",
        "name": "Calm_Woman",
        "gender": "neutral",
        "language": "zh",
        "provider": "minimax"
      },
      {
        "id": "Energetic_Girl",
        "name": "Energetic_Girl",
        "gender": "neutral",
        "language": "zh",
        "provider": "minimax"
      },
      {
        "id": "Patient_Man",
        "name": "Patient_Man",
        "gender": "neutral",
        "language": "zh",
        "provider": "minimax"
      },
      {
        "id": "Gentle_Woman",
        "name": "Gentle_Woman",
        "gender": "neutral",
        "language": "zh",
        "provider": "minimax"
      },
      {
        "id": "Warm_Man",
        "name": "Warm_Man",
        "gender": "neutral",
        "language": "zh",
        "provider": "minimax"
      },
      {
        "id": "Sweet_Girl_2",
        "name": "Sweet_Girl_2",
        "gender": "neutral",
        "language": "zh",
        "provider": "minimax"
      }
    ],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "zh",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "no": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "nb-NO-PernilleNeural",
        "name": "Pernille (NO)",
        "gender": "female",
        "language": "no",
        "provider": "edge_tts"
      },
      {
        "id": "nb-NO-FinnNeural",
        "name": "Finn (NO)",
        "gender": "male",
        "language": "no",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "no",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "be": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "be",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "co": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "co",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "eu": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "eu",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "fy": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "fy",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "fur": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "fur",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "gl": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "gl-ES-SabelaNeural",
        "name": "Sabela (ES)",
        "gender": "female",
        "language": "gl",
        "provider": "edge_tts"
      },
      {
        "id": "gl-ES-RoiNeural",
        "name": "Roi (ES)",
        "gender": "male",
        "language": "gl",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "gl",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "lb": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "lb",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "lmo": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "lmo",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ltg": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ltg",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "scn": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "scn",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "szl": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "szl",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "uk": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "uk-UA-PolinaNeural",
        "name": "Polina (UA)",
        "gender": "female",
        "language": "uk",
        "provider": "edge_tts"
      },
      {
        "id": "uk-UA-OstapNeural",
        "name": "Ostap (UA)",
        "gender": "male",
        "language": "uk",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "uk",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "vec": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "vec",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "yi": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "yi",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ace": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ace",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ay": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ay",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ban": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ban",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "bho": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "bho",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "bjn": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "bjn",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "bug": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "bug",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ceb": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ceb",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "dv": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "dv",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ilo": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ilo",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "iw": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "iw",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "jv": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "jv-ID-SitiNeural",
        "name": "Siti (ID)",
        "gender": "female",
        "language": "jv",
        "provider": "edge_tts"
      },
      {
        "id": "jv-ID-DimasNeural",
        "name": "Dimas (ID)",
        "gender": "male",
        "language": "jv",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "jv",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "kas": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "kas",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "km": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "km-KH-SreymomNeural",
        "name": "Sreymom (KH)",
        "gender": "female",
        "language": "km",
        "provider": "edge_tts"
      },
      {
        "id": "km-KH-PisethNeural",
        "name": "Piseth (KH)",
        "gender": "male",
        "language": "km",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "km",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "lo": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "lo-LA-KeomanyNeural",
        "name": "Keomany (LA)",
        "gender": "female",
        "language": "lo",
        "provider": "edge_tts"
      },
      {
        "id": "lo-LA-ChanthavongNeural",
        "name": "Chanthavong (LA)",
        "gender": "male",
        "language": "lo",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "lo",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "mai": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "mai",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "min": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "min",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "mn": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "mn-MN-YesuiNeural",
        "name": "Yesui (MN)",
        "gender": "female",
        "language": "mn",
        "provider": "edge_tts"
      },
      {
        "id": "mn-MN-BataaNeural",
        "name": "Bataa (MN)",
        "gender": "male",
        "language": "mn",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "mn",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "mni-mtei": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "mni-mtei",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "pag": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "pag",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ps": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "ps-AF-LatifaNeural",
        "name": "Latifa (AF)",
        "gender": "female",
        "language": "ps",
        "provider": "edge_tts"
      },
      {
        "id": "ps-AF-GulNawazNeural",
        "name": "GulNawaz (AF)",
        "gender": "male",
        "language": "ps",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ps",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "qu": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "qu",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "sa": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "sa",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "su": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "su-ID-TutiNeural",
        "name": "Tuti (ID)",
        "gender": "female",
        "language": "su",
        "provider": "edge_tts"
      },
      {
        "id": "su-ID-JajangNeural",
        "name": "Jajang (ID)",
        "gender": "male",
        "language": "su",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "su",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "tg": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "tg",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "th": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "th-TH-PremwadeeNeural",
        "name": "Premwadee (TH)",
        "gender": "female",
        "language": "th",
        "provider": "edge_tts"
      },
      {
        "id": "th-TH-NiwatNeural",
        "name": "Niwat (TH)",
        "gender": "male",
        "language": "th",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "th",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [
      {
        "id": "auto",
        "name": "Auto",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox"
      },
      {
        "id": "neutral",
        "name": "Neutral",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox"
      },
      {
        "id": "happy",
        "name": "Happy",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox"
      },
      {
        "id": "sad",
        "name": "Sad",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox"
      },
      {
        "id": "angry",
        "name": "Angry",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox"
      },
      {
        "id": "surprised",
        "name": "Surprised",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox"
      },
      {
        "id": "fearful",
        "name": "Fearful",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox"
      },
      {
        "id": "disgusted",
        "name": "Disgusted",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox"
      },
      {
        "id": "clone_from_reference",
        "name": "Voice Clone (Custom)",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox"
      }
    ],
    "minimax": [],
    "chatterbox_turbo": [
      {
        "id": "lucy",
        "name": "lucy",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "oliver",
        "name": "oliver",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "nova",
        "name": "nova",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "aria",
        "name": "aria",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox_turbo"
      },
      {
        "id": "echo",
        "name": "echo",
        "gender": "neutral",
        "language": "th",
        "provider": "chatterbox_turbo"
      }
    ],
    "elevenlabs": []
  },
  "tk": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "tk",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "tl": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "fil-PH-BlessicaNeural",
        "name": "Blessica (PH)",
        "gender": "female",
        "language": "tl",
        "provider": "edge_tts"
      },
      {
        "id": "fil-PH-AngeloNeural",
        "name": "Angelo (PH)",
        "gender": "male",
        "language": "tl",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "tl",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ug": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ug",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "war": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "war",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "bm": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "bm",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ee": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ee",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ha": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ha",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ig": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ig",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "kab": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "kab",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "kam": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "kam",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "knc": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "knc",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "kri": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "kri",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "lg": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "lg",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ln": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ln",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "luo": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "luo",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "mg": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "mg",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "nus": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "nus",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ny": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ny",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "rw": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "rw",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "sm": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "sm",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "sn": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "sn",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "so": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "so-SO-UbaxNeural",
        "name": "Ubax (SO)",
        "gender": "female",
        "language": "so",
        "provider": "edge_tts"
      },
      {
        "id": "so-SO-MuuseNeural",
        "name": "Muuse (SO)",
        "gender": "male",
        "language": "so",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "so",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "st": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "st",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "taq": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "taq",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ti": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ti",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "ts": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "ts",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "xh": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "xh",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "yo": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "yo",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "zu": {
    "kokoro": [],
    "edge_tts": [
      {
        "id": "zu-ZA-ThandoNeural",
        "name": "Thando (ZA)",
        "gender": "female",
        "language": "zu",
        "provider": "edge_tts"
      },
      {
        "id": "zu-ZA-ThembaNeural",
        "name": "Themba (ZA)",
        "gender": "male",
        "language": "zu",
        "provider": "edge_tts"
      }
    ],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "zu",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "crh": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "crh",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  },
  "haw": {
    "kokoro": [],
    "edge_tts": [],
    "google": [],
    "pyttsx3": [
      {
        "id": "default",
        "name": "Robot Voice (Bad Quality)",
        "gender": "neutral",
        "language": "haw",
        "provider": "pyttsx3"
      }
    ],
    "f5_tts": [],
    "chatterbox": [],
    "minimax": [],
    "chatterbox_turbo": [],
    "elevenlabs": []
  }
};

// ============================================
// HELPER FUNCTIONS
// ============================================

export function getVoicesForLanguageAndProvider(
  language: Language,
  provider: TTSProvider
): VoiceOption[] {
  return TTS_VOICES[language]?.[provider] || [];
}

export function getDefaultVoiceForLanguageAndProvider(
  language: Language,
  provider: TTSProvider
): string {
  const voices = getVoicesForLanguageAndProvider(language, provider);
  return voices[0]?.id || 'default';
}

// Helper function to check if in serverless environment
export function isRealServerlessEnvironment(): boolean {
  // In browser/Vite environment, only check import.meta.env
  const env: any = typeof import.meta !== 'undefined' && import.meta.env 
    ? import.meta.env 
    : {};
  
  if (env.RUNPOD_POD_ID || env.K_SERVICE) {
    return true;
  }
  
  const serverlessUrl = env.VITE_SERVERLESS_API_URL as string | undefined;
  if (serverlessUrl) {
    try {
      const url = new URL(serverlessUrl);
      return !['localhost', '127.0.0.1', '0.0.0.0'].includes(url.hostname);
    } catch {
      return false;
    }
  }
  
  return false;
}

// Transform helpers for backward compatibility
export function transformLlmProviders(providers: any[]): SelectOption[] {
  // Defensive check: ensure providers is an array
  if (!Array.isArray(providers)) {
    console.warn('[transformLlmProviders] providers is not an array:', providers);
    return [];
  }
  return providers.map((provider: any) => ({
    ...provider,
    disabled: provider.value === 'ollama' ? isRealServerlessEnvironment() : provider.disabled
  }));
}

export function transformLlmModels(models: Record<string, any[]>): Record<string, SelectOption[]> {
  // Defensive check: ensure models is an object
  if (!models || typeof models !== 'object') {
    console.warn('[transformLlmModels] models is not an object:', models);
    return {};
  }
  return Object.fromEntries(
    Object.entries(models).map(([provider, modelList]: [string, any[]]) => [
      provider,
      (Array.isArray(modelList) ? modelList : []).map((model) => ({
        ...model,
        disabled: model.disabled !== false ? model.disabled : model.free === false
      }))
    ])
  );
}
